/* eslint-disable max-lines */
const TRACKING_IDS = {
  alerts: {
    actionMenu: {
      addBoards: 'alerts_action-menu--add-boards',
      addMenu: 'alerts_action-menu--add-menu',
      addToDigest: 'alerts_action-menu--add-to-digest',
      addTopics: 'alerts_action-menu--add-topics',
      addWhyItMatters: 'alerts_action-menu--add-why-it-matters',
      block: 'alerts_action-menu--block',
      bulkActions: {
        select: 'alerts_action-menu--bulk-actions-select',
        selectAll: 'alerts_action-menu--bulk-actions-select-all',
        selectMenu: 'alerts_action-menu--bulk-actions-select-menu',
      },
      delete: 'alerts_action-menu--delete',
      editWhyItMatters: 'alerts_action-menu--edit-why-it-matters',
      move: {
        archived: 'alerts_action-menu--move-archived',
        deleted: 'alerts_action-menu--move-deleted',
        unprocessed: 'alerts_action-menu--move-unprocessed',
        working: 'alerts_action-menu--move-working',
      },
      moveMenu: 'alerts_action-menu--move-menu',
      newPageAlert: 'alerts_action-menu--new-page-alert',
      priority: {
        important: 'alerts_action-menu--priority-important',
        interesting: 'alerts_action-menu--priority-interesting',
      },
      priorityMenu: 'alerts_action-menu--priority-menu',
      publish: 'alerts_action-menu--publish',
      removeFromDigest: 'alerts_action-menu--remove-from-digest',
      shareToMenu: 'alerts_action-menu--share-to-menu',
      shareToSlack: 'alerts_action-menu--share-to-slack',
      unblock: 'alerts_action-menu--unblock',
      unpublish: 'alerts_action-menu--unpublish',
      copy: 'alerts_action-menu--copy',
    },
    actions: {
      addToDigest: 'alerts_actions--add-to-digest',
      delete: 'alerts_actions--delete',
      monitor: 'alerts_actions--monitor',
      publish: 'alerts_actions--publish',
      removeFromDigest: 'alerts_actions--remove-from-digest',
      unpublish: 'alerts_actions--unpublish',
      viewInDigest: 'alerts_actions--view-in-digest',
    },
    dateDivider: {
      last7days: 'alerts_date-divider--last-7-days',
      last30days: 'alerts_date-divider--last-30-days',
      last90days: 'alerts_date-divider--last-90-days',
      menu: 'alerts_date-divider--menu',
      today: 'alerts_date-divider--today',
      yesterday: 'alerts_date-divider--yesterday',
    },
    intelCard: {
      badges: {
        comments: 'alerts_intel-card-badge--comments',
        newPageAlert: 'alerts_intel-card-badge--new-page-alert',
        publishedToFeed: 'alerts_intel-card-badge--published-to-feed',
        viewInDigest: 'alerts_intel-card-badge--view-in-digest',
      },
      collapseButton: 'alerts_intel-card--collapse-button',
      collapseRepliesCountButton:
        'alerts_intel-card--collapse-replies-count-button',
      collapseRepliesThreadButton:
        'alerts_intel-card--collapse-replies-thread-button',
      expandButton: 'alerts_intel-card--expand-button',
      expandRepliesCountButton:
        'alerts_intel-card--expand-replies-count-button',
      expandRepliesThreadButton:
        'alerts_intel-card--expand-replies-thread-button',
      footer: {
        addTopics: 'alerts_intel-card-footer--add-topics',
        removePriorityTag: 'alerts_intel-card-footer--remove-priority-tag',
        removeTopic: 'alerts_intel-card-footer--remove-topic',
      },
      header: {
        sourcePermalink: 'alerts_intel-card-header--source-permalink',
      },
      relatedAlert: {
        anchorLink: 'alerts_intel-card-related-alert--anchor-link',
        removeLink: 'alerts_intel-card-related-alert--remove-link',
        text: 'alerts_intel-card-related-alert--text',
      },
      relatedBoards: {
        addBoardItem: 'alerts_intel-card-related-boards--add-board-item',
        addBoardMenu: 'alerts_intel-card-related-boards--add-board-menu',
        board: 'alerts_intel-card-related-boards--board',
        filter: 'alerts_intel-card-related-boards--filter',
        remove: 'alerts_intel-card-related-boards--remove',
        viewBoard: 'alerts_intel-card-related-boards--view-board',
      },
      title: {
        cancel: 'alerts_intel-card-title--cancel',
        edit: 'alerts_intel-card-title--edit',
        revertToOriginal: 'alerts_intel-card-title--revert-to-original',
        save: 'alerts_intel-card-title--save',
      },
      viewFullAlertInFeed: 'alerts_intel-card--view-full-alert-in-feed',
    },
    intelList: {
      errors: {
        genericError: {
          action: 'alerts_intel-list-error-action--reload-alerts',
          errorContainer: 'alerts_intel-list-error--generic-error',
        },
        invalidQuery: {
          action: 'alerts_intel-list-error-action--reset-alerts',
          errorContainer: 'alerts_intel-list-error--invalid-query',
        },
      },
    },
    leftMenu: {
      allIntel: 'alerts_left-menu--all-intel',
      archived: 'alerts_left-menu--all-archived',
      deleted: 'alerts_left-menu--all-deleted',
      important: 'alerts_left-menu--important',
      interesting: 'alerts_left-menu--interesting',
      myNewIntel: 'alerts_left-menu--my-new-intel',
      published: 'alerts_left-menu--published',
      reviewInsights: 'alerts_left-menu--reviewInsights',
      searchSavedViews: 'alerts_left-menu--search-saved-views',
      sections: {
        mySavedViews: 'alerts_left-menu--section-my-saved-views',
        smartSets: 'alerts_left-menu--section-smart-sets',
        states: 'alerts_left-menu--section-states',
      },
      selectedSavedView: 'alerts_left-menu--selected-saved-view',
      settings: 'alerts_left-menu--settings',
      unprocessed: 'alerts_left-menu--all-unprocessed',
      working: 'alerts_left-menu--all-working',
    },
    rightMenu: {
      boardGroups: 'alerts_right-menu--boardGroups',
      boards: 'alerts_right-menu--boards',
      customDateRange: {
        checked: 'alerts_right-menu--customDateRange-radio-checked',
        unchecked: 'alerts_right-menu--customDateRange-radio-unchecked',
      },
      dateRange: 'alerts_right-menu--dateRange',
      emptyUserBoardsNoticeAnchor:
        'alerts_right-menu--ny-boards-empty-notice-anchor',
      myBoards: 'alerts_right-menu--myBoards',
      priorities: 'alerts_right-menu--priorities',
      processedByMe: {
        toggle: 'alerts_right-menu--processed-by-me_toggle',
      },
      sort: 'alerts_right-menu--sort',
      sources: 'alerts_right-menu--sources',
      states: 'alerts_right-menu--states',
      topics: 'alerts_right-menu--topics',
      types: 'alerts_right-menu--types',
    },
    shareToSlackModal: {
      connect: 'alerts_share-to-slack-modal--connect',
      reconnect: 'alerts_share-to-slack-modal--reconnect',
      selectChannelDropdown:
        'alerts_share-to-slack-modal--select-channel-dropdown',
      selectChannelItemPrefix:
        'alerts_share-to-slack-modal--select-channel-item',
      selectChannelSelectedItemPrefix:
        'alerts_share-to-slack-modal--select-channel-selected-item',
      send: 'alerts_share-to-slack-modal--send',
    },
    topBar: {
      bulkActions: {
        addToDigest: 'alerts_top-bar--bulk-actions-add-to-digest',
        archive: 'alerts_top-bar--bulk-actions-archive',
        boardsDropdown: {
          apply: 'alerts_top-bar--bulk-actions-boards-dropdown-apply',
          boards: 'alerts_top-bar--bulk-actions-boards-dropdown-boards',
          button: 'alerts_top-bar--bulk-actions-boards-dropdown',
          cancel: 'alerts_top-bar--bulk-actions-boards-dropdown-cancel',
          myBoards: {
            apply:
              'alerts_top-bar--bulk-actions-boards-dropdown-myboards-apply',
            button: 'alerts_top-bar--bulk-actions-boards-dropdown-myboards',
            cancel:
              'alerts_top-bar--bulk-actions-boards-dropdown-myboards-cancel',
          },
        },
        cancel: 'alerts_top-bar--bulk-actions-cancel-button',
        cancelAction: 'alerts_top-bar--bulk-actions-cancel-action',
        confirmAction: 'alerts_top-bar--bulk-actions-confirm-action',
        delete: 'alerts_top-bar--bulk-actions-delete',
        enable: 'alerts_top-bar--bulk-actions-enable-button',
        moveToDropdown: {
          apply: 'alerts_top-bar--bulk-actions-move-to-dropdown-apply',
          button: 'alerts_top-bar--bulk-actions-move-to-dropdown',
          cancel: 'alerts_top-bar--bulk-actions-move-to-dropdown-cancel',
        },
        prioritizeDropdown: {
          apply: 'alerts_top-bar--bulk-actions-prioritize-dropdown-apply',
          button: 'alerts_top-bar--bulk-actions-prioritize-dropdown',
          cancel: 'alerts_top-bar--bulk-actions-prioritize-dropdown-cancel',
        },
        publish: 'alerts_top-bar--bulk-actions-publish',
        selectAll: 'alerts_top-bar--bulk-actions--select-all',
        selectAllCheckbox: 'alerts_top-bar--bulk-actions-select-all-checkbox',
        selectDropdown: {
          selectAll: 'alerts_top-bar--bulk-actions-select-dropdown-select-all',
          selectNone:
            'alerts_top-bar--bulk-actions-select-dropdown-select-none',
        },
        selectNone: 'alerts_top-bar--bulk-actions--select-none',
        topicsDropdown: {
          apply: 'alerts_top-bar--bulk-actions-topics-dropdown-apply',
          button: 'alerts_top-bar--bulk-actions-topics-dropdown',
          cancel: 'alerts_top-bar--bulk-actions-topics-dropdown-cancel',
        },
      },
      container: 'alerts_top-bar--container',
      filters: {
        allAlerts: 'alerts_top-bar--filters-all-alerts',
        processedBy: 'alerts_top-bar--filters-processed-by',
      },
      savedViews: {
        actionsDropdown: {
          createNewViewButton:
            'alerts_top-bar_saved-views--actions-dropdown--create-new-view-button',
          deleteButton:
            'alerts_top-bar_saved-views--actions-dropdown--delete-button',
          renameButton:
            'alerts_top-bar_saved-views--actions-dropdown--rename-button',
          splitButton:
            'alerts_top-bar_saved-views--actions-dropdown--split-button',
        },
        createNewViewButton:
          'alerts_top-bar_saved-views--create-new-view-button',
        input: {
          cancelButton: 'alerts_top-bar_saved-views--input--cancel-button',
          saveNameButton: 'alerts_top-bar_saved-views--input--save-name-button',
        },
        listOfViewsDropdownButton:
          'alerts_top-bar_saved-views--list-of-views-dropdown-button',
        resetButton: 'alerts_top-bar_saved-views--reset-button',
        savedSplitButton: 'alerts_top-bar_saved-views--saved-split-button',
        saveSplitButton: 'alerts_top-bar_saved-views--save-split-button',
        selectSavedViews: 'alerts_top-bar_saved-views--select-saved-views',
      },
      triageToogleBox: 'alerts_top-bar--triage-toggle-box',
      triageToogleOFF: 'alerts_top-bar--triage-toggle-off',
      triageToogleON: 'alerts_top-bar--triage-toggle-on',
    },
    triageActions: {
      addToImportant: 'alerts_triage-actions--tag-as-important',
      addToInteresting: 'alerts_triage-actions--tag-as-interesting',
      back: 'alerts_triage-actions--back',
      moveToArchived: 'alerts_triage-actions--move-to-archived',
      moveToDeleted: 'alerts_triage-actions--move-to-deleted',
      skip: 'alerts_triage-actions--skip',
    },
  },
  askKlue: {
    answer: {
      addToDigestButton: 'ask-klue--answer-add-to-digest-button',
      createCardButton: 'ask-klue--answer-create-card-button',
      viewCardButton: 'ask-klue--answer-view-card-button',
      scheduleCardButton: 'ask-klue--answer-schedule-card-button',
    },
    createCardModal: {
      rivalSelector: 'ask-klue-create-card-modal-rival-selector',
      laneSelector: 'ask-klue-create-card-modal-lane-selector',
      addLaneButton: 'ask-klue-create-card-modal-add-lane-button',
      addLaneSubmit: 'ask-klue-create-card-modal-add-lane-submit',
      createAndCloseButton:
        'ask-klue-create-card-modal-create-and-close-button',
      editCardButton: 'ask-klue-create-card-modal-edit-card-button',
    },
    askKlueButton: 'ask-klue--ask-klue-button',
    askKlueInput: 'ask-klue--ask-klue-input',
    feedback: {
      yesButton: 'ask-klue--feedback-yes-button',
      noButton: 'ask-klue--feedback-no-button',
      skipButton: 'ask-klue--feedback-skip-button',
      submitButton: 'ask-klue--feedback-submit-button',
      dismissButton: 'ask-klue--feedback-dismiss-button',
    },
    singleClickPromptButton: 'ask-klue--single-click-prompt-button',
    wizardButton: 'ask-klue--wizard-button',
    dashboardConsumerToggle: 'ask-klue--dashboard-consumer-toggle',
    viewAs: {
      select: 'ask-klue--view-as-select',
      selectItem: 'ask-klue--view-as-select-item',
    },
    researchMode: {
      toggleChecked: 'ask-klue--research-mode-toggle-checked',
      sourceSelectorButton: 'ask-klue--source-selector-button',
      sourceSelectorCheckbox: 'ask-klue--source-selector-checkbox',
      sourceSelectorDropdown: 'ask-klue--source-selector-dropdown',
    },
    sidebar: {
      searchInput: 'ask-klue-sidebar-search-input',
      item: 'ask-klue-sidebar-item',
    },
    advancedWizard: {
      cancel: 'ask-klue-advanced-wizard--cancel',
      apply: 'ask-klue-advanced-wizard--apply',
      boardSelect: 'ask-klue-advanced-wizard--board-select',
      laneSelect: 'ask-klue-advanced-wizard--lane-select',
      addLane: 'ask-klue-advanced-wizard--add-lane',
    },
  },
  callInsights: {
    competitorFilterDrop: 'call-insights_competitor-filter-drop',
    competitorFilterPrefix: 'call-insights_competitor-filter',
    dateRangeFilter: 'call-insights_date-range-filter',
    dealStageFilterDrop: 'call-insights_deal-stage-filter-drop',
    dealStageFilterPrefix: 'call-insights_deal-stage-filter',
    trackerFilterDrop: 'call-insights_tracker-filter-drop',
    trackerFilterPrefix: 'call-insights_tracker-filter',
    requestCallProvider: 'call-insights_request-call-provider',
    showLess: 'call-insights_show-less',
    showMore: 'call-insights_show-more',
    manageAliases: 'call-insights_manage-aliases',
    summarizeWidget: {
      summarizeButton: 'call-insights_summarize-widget--summarize-button',
      deleteSummaryButton:
        'call-insights_summarize-widget--delete-summary-button',
      retryButton: 'call-insights_summarize-widget--retry-button',
    },
  },
  dealTips: {
    userFilterDrop: 'deal-tips_user-filter-drop',
    clearFilter: 'deal-tips_clear-filter',
    listItem: 'deal-tips_list-item',
    pagination: {
      firstPage: 'deal-tips_pagination-first-page',
      prevPage: 'deal-tips_pagination-prev-page',
      nextPage: 'deal-tips_pagination-next-page',
      lastPage: 'deal-tips_pagination-last-page',
    },
    settings: {
      slackNotifyMe: 'deal-tips_settings--slack-notify-me',
      teamsNotifyMe: 'deal-tips_settings--teams-notify-me',
    },
  },
  dsq: {
    diffView: {
      toggleBtn: 'dsq_diff-view--toggle-btn',
    },
    regeneration: {
      undoBtn: 'dsq_regeneration--undo-btn',
      viewChangesBtn: 'dsq_regeneration--view-changes-btn',
    },
    selectionAction: {
      addToChat: 'dsq_selection-action--add-to-chat',
    },
    versionHistory: {
      toggleBtn: 'dsq_version-history--toggle-btn',
      versionEntry: 'dsq_version-history--version-entry',
      closeBtn: 'dsq_version-history--close-btn',
      restoreBannerBtn: 'dsq_version-history--restore-banner-btn',
      restoreConfirmBtn: 'dsq_version-history--restore-confirm-btn',
      restoreCancelBtn: 'dsq_version-history--restore-cancel-btn',
      returnToCurrentBtn: 'dsq_version-history--return-to-current-btn',
    },
  },
  companyPage: {
    overview: {
      footerCitation: 'company-page_overview--footer-citation',
      inlineCitation: 'company-page_overview--inline-citation',
      shareLink: 'company-page_overview--share-link',
    },
    settings: {
      actionButton: 'company-page_settings--action-button',
      cancelButton: 'company-page_settings--cancel-button',
      closeButton: 'company-page_settings--close-button',
      publicSourcesToggle: 'company-page_settings--public-sources-toggle',
      saveButton: 'company-page_settings--save-button',
    },
    sideNav: {
      battlecards: 'company-page_side-nav--battlecards',
      companyName: 'company-page_side-nav--company-name',
      news: 'company-page_side-nav--news',
      profile: 'company-page_side-nav--profile',
    },
    whatsNew: {
      inlineCitation: 'company-page_whats-new--inline-citation',
    },
  },
  composer: {
    battlecardView: 'composer_battlecard-view',
    cancelGeneration: 'composer-cancel-generation',
    cardNavigate: 'composer_card-navigate',
    continueEditing: 'composer_continue-editing',
    deleteProject: {
      button: 'composer_delete-project--button',
      cancel: 'composer_delete-project--cancel',
      confirm: 'composer_delete-project--confirm',
    },
    error: {
      card: {
        retry: 'composer_error-card--retry',
        supportLink: 'composer_error-card--support-link',
      },
    },
    errorSources: {
      continue: 'composer_error-sources--continue',
      cancel: 'composer_error-sources--cancel',
    },
    fileAdd: 'composer_file-add',
    fileClick: {
      errorDialog: 'composer_file-click--error-dialog',
      filesList: 'composer_file-click--files-list',
      processingDialog: 'composer_file-click--processing-dialog',
      sourcesList: 'composer_file-click--sources-list',
    },
    fileDelete: 'composer_file-delete',
    fileSelect: 'composer_file-select',
    generate: {
      projectInstructions: 'composer_generate--instructions',
      projectNavbar: 'composer_generate--navbar',
      newDraft: 'composer_generate--new-draft',
    },
    improve: {
      card: 'composer_improve--card',
    },
    newDraft: {
      projectPublishSuccessModal: 'composer_new-draft--success-modal',
      projectsNavigation: 'composer_new-draft--navigation',
    },
    processingSources: {
      continue: 'composer_processing-sources--continue',
      cancel: 'composer_processing-sources--cancel',
    },
    projectActions: 'composer_project-actions',
    projectNavigate: 'composer_project-navigate',
    projectPublish: 'composer_project-publish',
    regenerate: {
      card: 'composer_regenerate--card',
    },
    rivalSelect: 'composer_rival-select',
    saveDraft: 'composer_save-draft',
    sendToBoard: 'composer_send-to-board',
    sentiment: {
      negative: 'composer_sentiment--negative',
      positive: 'composer_sentiment--positive',
    },
    sentimentCancel: 'composer_sentiment-cancel',
    sentimentSubmit: 'composer_sentiment-submit',
    sentimentTextareaFocus: 'composer_sentiment-textarea-focus',
    settingsNavigate: 'composer_project-settings-navigate',
    sideNav: {
      collapseArrow: 'composer_side-nav--collapse-arrow',
      contentHeader: 'composer_side-nav--content-header',
    },
    subNav: {
      createButton: 'composer_sub-nav--create-button',
      draftChooser: {
        button: 'composer_sub-nav--draft-chooser-button',
      },
    },
    suggestSourcesButton: 'composer_suggest-sources-button',
    templateToggle: 'composer_template-toggle',
    websiteAdd: 'composer_website-add',
    websiteInput: 'composer_website-input',
    websiteSubmit: 'composer_website-submit',
  },
  competeAnswerComparison: {
    vote: {
      A: 'compete-answer-comparison_vote--a',
      B: 'compete-answer-comparison_vote--b',
      both_equal: 'compete-answer-comparison_vote--both-equal',
    },
    navigation: {
      previous: 'compete-answer-comparison_navigation--previous',
      primary: 'compete-answer-comparison_navigation--primary',
    },
    returnToKlue: {
      header: 'compete-answer-comparison_return-to-klue--header',
      complete: 'compete-answer-comparison_return-to-klue--complete',
    },
  },
  consumer: {
    newsCard: {
      content: {
        intelMessageContent: {
          repliesCountButton: {
            collapse:
              'consumer-news-card--intel-message-content--replies-count-button--collapse',
            expand:
              'consumer-news-card--intel-message-content--replies-count-button--expand',
          },
          repliesThreadButton: {
            collapse:
              'consumer-news-card--intel-message-content--replies-thread-button--collapse',
            expand:
              'consumer-news-card--intel-message-content--replies-thread-button--expand',
          },
        },
      },
    },
  },
  dashboard: {
    curatorControls: {
      editGroups: 'dashboard-curator-controls_edit-groups',
      newBoard: 'dashboard-curator-controls_new-board',
      newBoardDrop: 'dashboard-curator-controls_new-board-drop',
      saveDefaults: 'dashboard-curator-controls_save-defaults',
      viewAs: 'dashboard-curator-controls_view-as',
    },
    filters: {
      groupDrop: {
        button: 'dashboard-filters_group-drop',
        itemPrefix: 'dashboard-filters_group-item',
      },
      sortDrop: {
        button: 'dashboard-filters_sort-drop',
        itemPrefix: 'dashboard-filters_sort-item',
      },
    },
    tabs: {
      boards: 'dashboard_tabs--boards',
      favorites: 'dashboard_tabs--favorites',
      news: 'dashboard_tabs--news',
    },
    news: {
      author: 'dashboard-news_author',
      board: 'dashboard-news_board',
      externalLink: 'dashboard-news_external-link',
      readMore: 'dashboard-news_read-more',
      toggleChecked: 'dashboard-news_toggle-checked',
      toggleUnchecked: 'dashboard-news_toggle-unchecked',
      wim: 'dashboard-news_why-it-matters',
    },
    newBoardModal: {
      cancel: 'dashboard_new-board-modal--cancel',
      close: 'dashboard_new-board-modal--close',
      companyPreviewToggle: 'dashboard_new-board-modal--company-preview-toggle',
      create: 'dashboard_new-board-modal--create',
      createConfirmCancel: 'dashboard_new-board-modal--create-confirm-cancel',
      createConfirmContinue:
        'dashboard_new-board-modal--create-confirm-continue',
      csvParseErrorAlertDismiss:
        'dashboard_new-board-modal--csv-parse-error-alert-dismiss',
      csvDuplicatesConfirmCancel:
        'dashboard_new-board-modal--csv-duplicates-confirm-cancel',
      csvDuplicatesConfirmContinue:
        'dashboard_new-board-modal--csv-duplicates-confirm-continue',
      done: 'dashboard_new-board-modal--done',
      downloadCompaniesTemplate:
        'dashboard_new-board-modal--download-companies-template',
      downloadScheduledCardsTemplate:
        'dashboard_new-board-modal--download-scheduled-cards-template',
      removeCompaniesCsvFile:
        'dashboard_new-board-modal--remove-companies-csv-file',
      removeScheduledCardsCsvFile:
        'dashboard_new-board-modal--remove-scheduled-cards-csv-file',
      scheduledCardsPreviewToggle:
        'dashboard_new-board-modal--scheduled-cards-preview-toggle',
      tabCards: 'dashboard_new-board-modal--tab-cards',
      tabCompany: 'dashboard_new-board-modal--tab-company',
      tabSettings: 'dashboard_new-board-modal--tab-settings',
      // Company tab form controls
      companyBoardName: 'dashboard_new-board-modal--company-board-name',
      companyBoardType: 'dashboard_new-board-modal--company-board-type',
      companyUrl: 'dashboard_new-board-modal--company-url',
      companyTemplate: 'dashboard_new-board-modal--company-template',
      // Cards tab controls
      cardsDragHandle: 'dashboard_new-board-modal--cards-drag-handle',
      cardsIncludedCheckbox:
        'dashboard_new-board-modal--cards-included-checkbox',
      cardsVisibility: 'dashboard_new-board-modal--cards-visibility',
      // Settings tab controls
      settingsPublished: 'dashboard_new-board-modal--settings-published',
      settingsCuratorAssignment:
        'dashboard_new-board-modal--settings-curator-assignment',
      settingsGroups: 'dashboard_new-board-modal--settings-groups',
      settingsApplyToCsv: 'dashboard_new-board-modal--settings-apply-to-csv',
      uploadCompaniesCsv: 'dashboard_new-board-modal--upload-companies-csv',
      uploadScheduledCardsCsv:
        'dashboard_new-board-modal--upload-scheduled-cards-csv',
    },
    rivalGroup: {
      accordion: 'dashboard-rival-group_accordion',
    },
    rivalItem: {
      battlecardsButton: 'dashboard-rival-item_battlecards-button',
      button: 'dashboard-rival-item_button',
      profileButton: 'dashboard-rival-item_profile-button',
    },
    competitive: {
      card: 'dashboard-competitive-card',
      callToAction: 'dashboard-competitive-call-to-action',
      emptyState: 'dashboard-competitive-empty-state',
    },
    alerts: {
      card: 'dashboard-competitive-card',
      callToAction: 'dashboard-competitive-call-to-action',
    },
  },
  editor: {
    tags: {
      addTag: 'editor-tags-add-tag',
    },
    visibilityGroups: {
      done: 'editor-visibility-groups-done',
    },
  },
  filterDropTab: 'filter-drop-tab',
  global: {
    appNavBar: {
      askKlue: 'app-nav-bar_ask-klue',
      alerts: 'app-nav-bar_alerts',
      boards: 'app-nav-bar_boards',
      competitiveAnalytics: 'app-nav-bar_competitive-analytics',
      composer: 'app-nav-bar_composer',
      consumerUsage: 'app-nav-bar_consumer-usage',
      curatorActivity: 'app-nav-bar_curator-activity',
      dealTips: 'app-nav-bar_deal-tips',
      digest: 'app-nav-bar_digest',
      discover: 'app-nav-bar_discover',
      feed: 'app-nav-bar_feed',
      globalSearch: {
        button: 'app-nav-bar_global-search-button',
        context: {
          alerts: 'app-nav-bar_global-search-context-alerts',
          cards: 'app-nav-bar_global-search-context-cards',
        },
        input: 'app-nav-bar_global-search-input',
        suggestions: {
          battlecard: {
            profile: 'app-nav-bar_global-search-suggestions-battlecard-profile',
            battlecardTitle:
              'app-nav-bar_global-search-suggestions-battlecard-title',
          },
        },
      },
      home: 'app-nav-bar_home',
      insights: 'app-nav-bar_insights',
      integrations: 'app-nav-bar_integrations',
      measure: 'app-nav-bar_measure',
      monitors: 'app-nav-bar_monitors',
      quickSwitcher: 'app-nav-bar_quick-switcher',
      research: 'app-nav-bar_research',
      responsiveMenu: 'app-nav-bar_responsive-menu',
      salesCalls: 'app-nav-bar_sales-calls',
      share: 'app-nav-bar_share',
      submitIntel: 'app-nav-bar_submit-intel',
      threatAnalysis: 'app-nav-threat-analysis',
      userMenu: 'app-nav-bar_user-menu',
    },
    card: {
      actionMenu: {
        button: 'card-action-button',
        copyEmbed: 'card-action-menu_copy-embed',
        copyLink: 'card-action-menu_copy-link',
        duplicateCard: 'card-action-menu_duplicate-card',
        moveCard: 'card-action-menu_move-card',
        edit: 'card-action-menu_edit',
        openCard: 'card-action-menu_open-card',
        sources: 'card-action-menu_sources',
        assignToBattlecards: 'card-action-menu_assign-to-battlecard',
        cardPermissions: 'card-action-menu_card-permissions',
        addToDigest: 'card-action-menu_add-to-digest',
      },
      addToDigest: {
        cancel: 'add-to-digest_cancel',
        confirm: 'add-to-digest_confirm',
        digestSelect: 'add-to-digest_digest-select',
      },
      copyToBoards: {
        addLane: 'copy-to-boards--add-lane',
        boardSelect: 'copy-to-boards--board-select',
        cancel: 'copy-to-boards--cancel',
        copy: 'copy-to-boards--copy',
        laneSelect: 'copy-to-boards--lane-select',
      },
      moveCard: {
        cancelButton: 'move-card_cancel-button',
        boardSelect: 'move-card_board_select',
        boardSelectItem: 'move-card_board_select-item',
        laneSelect: 'move-card_lane_select',
        laneSelectItem: 'move-card_lane_select-item',
        submitButton: 'move-card_submit-button',
      },
      author: 'card-author',
      collapseButton: {
        showAll: 'card-collapse-button-show-all',
        showFewer: 'card-collapse-button-show-fewer',
      },
      sentiment: {
        negative: 'card-sentiment_negative',
        positive: 'card-sentiment_positive',
      },
      shareFeedback: {
        cancel: 'card-sentiment_share-feedback_cancel',
        cancelModal: 'card-sentiment_share-feedback_modal_cancel',
        openModal: 'card-sentiment_share-feedback_modal',
        send: 'card-sentiment_share-feedback_send',
        sendModal: 'card-sentiment_share-feedback_modal_send',
        share: 'card-sentiment_share-feedback',
      },
      title: 'card-title',
      toolbar: {
        copyEmbed: 'card-toolbar_copy-embed',
        copyLink: 'card-toolbar_copy-link',
        duplicateCard: 'card-toolbar_duplicate-card',
        openCard: 'card-toolbar_open-card',
        sources: 'card-toolbar_sources',
      },
    },
    cardViewer: {
      backButton: 'card-viewer_back-button',
      breadcrumbs: {
        author: 'card-viewer_breadcrumbs-author',
        board: 'card-viewer_breadcrumbs-board',
        lane: 'card-vewer_breadcrumbs-lane',
      },
      closeButton: 'card-viewer_close-button',
      editButton: 'card-viewer_edit-button',
      fullscreenButton: 'card-viewer_fullscreen-button',
    },
    previewBanner: {
      dropdown: 'preview-banner-group-dropdown',
      reset: 'preview-banner-group-reset',
    },
    profileCard: {
      battlecard: 'profile-card-battlecard',
      viewAllCards: 'profile-card-view-all-cards',
    },
    submitIntel: {
      cancelButton: 'submit-intel_cancel-button',
      select: 'submit-intel_select',
      selectItem: 'submit-intel_select-item',
      submitButton: 'submit-intel_submit-button',
    },
    summary: {
      cancel: 'alerts_summary--cancel',
      delete: 'alerts_summary--delete',
      edit: 'alerts_summary--edit',
      feedback: 'alerts_summary--feedback',
      menu: 'alerts_summary--menu',
      options: {
        format: {
          bullets: 'alerts_summary--options-format-bullets',
          paragraphs: 'alerts_summary--options-format-paragraphs',
        },
        length: {
          concise: 'alerts_summary--options-length-concise',
          lengthy: 'alerts_summary--options-length-lengthy',
        },
        tone: {
          friendly: 'alerts_summary--options-tone-friendly',
          professional: 'alerts_summary--options-tone-professional',
        },
      },
      retry: 'alerts_summary--retry',
      save: 'alerts_summary--save',
      summarize: 'alerts_summary--summarize',
      tryAgain: 'alerts_summary--error-retry',
    },
    supportedRivalCard: {
      viewProfile: 'supportedRival-card-view-profile',
    },
  },
  hatch: {
    account: {
      connectedApps: {
        manage: 'hatch_account-connected-apps--manage',
      },
      sessions: {
        manage: 'hatch_account-sessions--manage',
      },
      password: {
        reset: 'hatch_account-password--reset',
      },
      role: {
        edit: 'hatch_account-role--edit',
        reset: 'hatch_account-role--reset',
        save: 'hatch_account-role--save',
      },
    },
    analytics: {
      competitorFilter: 'hatch_analytics-revenue--competitor-filter',
      dealTypeFilter: 'hatch_analytics-revenue--deal-type-filter',
      regionFilter: 'hatch_analytics-revenue--region-filter',
      roleFilter: 'hatch_analytics-engagement--role-filter',
    },
    agentTasks: {
      newTaskCancel: 'hatch_agent-tasks--new-task-cancel',
      newTaskLaunch: 'hatch_agent-tasks--new-task-launch',
    },
    blindspots: {
      reportRead: 'hatch_blindspots--report-read',
    },
    workspace: {
      moduleAction: 'hatch_workspace--module-action',
      moduleTab: 'hatch_workspace--module-tab',
      sideNavModule: 'hatch_workspace--side-nav-module',
      sideNavModuleClassic: 'hatch_workspace--side-nav-module-classic',
      sideNavSearch: 'hatch_workspace--side-nav-search',
    },
    customerProof: {
      library: {
        attendeeFilter: 'hatch_customer-proof--library-attendee-filter',
        attendeeFilterClear:
          'hatch_customer-proof--library-attendee-filter-clear',
        attendeeFilterPerson:
          'hatch_customer-proof--library-attendee-filter-person',
        clearFilters: 'hatch_customer-proof--library-clear-filters',
        copyQuote: 'hatch_customer-proof--library-copy-quote',
        downloadImage: 'hatch_customer-proof--library-download-image',
        moreActions: 'hatch_customer-proof--library-more-actions',
        editQuote: 'hatch_customer-proof--library-edit-quote',
        remove: 'hatch_customer-proof--library-remove',
        removeCancel: 'hatch_customer-proof--library-remove-cancel',
        removeConfirm: 'hatch_customer-proof--library-remove-confirm',
        removeBack: 'hatch_customer-proof--library-remove-back',
        removeReason: 'hatch_customer-proof--library-remove-reason',
        requestApproval: 'hatch_customer-proof--library-request-approval',
        requestResearch: 'hatch_customer-proof--library-request-research',
        rowOpen: 'hatch_customer-proof--library-row-open',
        searchClear: 'hatch_customer-proof--library-search-clear',
        sendAnyway: 'hatch_customer-proof--library-send-anyway',
        settings: 'hatch_customer-proof--library-settings',
        rangeOption: {
          week: 'hatch_customer-proof--library-range-this-week',
          '30d': 'hatch_customer-proof--library-range-30-days',
          all: 'hatch_customer-proof--library-range-all-time',
        },
        seeWhatsOutstanding:
          'hatch_customer-proof--library-see-whats-outstanding',
        sortSelect: 'hatch_customer-proof--library-sort-select',
        sortOption: {
          match: 'hatch_customer-proof--library-sort-best-match',
          newest: 'hatch_customer-proof--library-sort-newest',
          oldest: 'hatch_customer-proof--library-sort-oldest',
          best: 'hatch_customer-proof--library-sort-best',
          recent: 'hatch_customer-proof--library-sort-recently-approved',
        },
        statusFilter: 'hatch_customer-proof--library-status-filter',
        statusFilterOption: {
          all: 'hatch_customer-proof--library-status-filter-all',
          not_asked: 'hatch_customer-proof--library-status-filter-not-asked',
          awaiting: 'hatch_customer-proof--library-status-filter-awaiting',
          approved: 'hatch_customer-proof--library-status-filter-approved',
          declined: 'hatch_customer-proof--library-status-filter-declined',
        },
        takeBack: 'hatch_customer-proof--library-take-back',
        undoRequest: 'hatch_customer-proof--library-undo-request',
        tabApproved: 'hatch_customer-proof--library-tab-approved',
        tabLibrary: 'hatch_customer-proof--library-tab-library',
        welcomeDismiss: 'hatch_customer-proof--library-welcome-dismiss',
      },
      sheet: {
        close: 'hatch_customer-proof--sheet-close',
        copyImage: 'hatch_customer-proof--sheet-copy-image',
        copyQuote: 'hatch_customer-proof--sheet-copy-quote',
        downloadPng: 'hatch_customer-proof--sheet-download-png',
        editCancel: 'hatch_customer-proof--sheet-edit-cancel',
        editDone: 'hatch_customer-proof--sheet-edit-done',
        editQuote: 'hatch_customer-proof--sheet-edit-quote',
        editQuoteLocked: 'hatch_customer-proof--sheet-edit-quote-locked',
        editSave: 'hatch_customer-proof--sheet-edit-save',
        openCall: 'hatch_customer-proof--sheet-open-call',
        openInGong: 'hatch_customer-proof--sheet-open-in-gong',
        requestApproval: 'hatch_customer-proof--sheet-request-approval',
        restoreOriginal: 'hatch_customer-proof--sheet-restore-original',
        share: {
          trigger: 'hatch_customer-proof--sheet-share-trigger',
          copyLink: 'hatch_customer-proof--sheet-share-copy-link',
          slack: 'hatch_customer-proof--sheet-share-slack',
          teams: 'hatch_customer-proof--sheet-share-teams',
        },
      },
      settings: {
        emailTab: 'hatch_customer-proof--settings-email-tab',
        manageSources: 'hatch_customer-proof--settings-manage-sources',
        productMapTab: 'hatch_customer-proof--settings-product-map-tab',
      },
    },
    competitors: {
      battlecardsNoTiers: 'hatch_competitors--battlecards-no-tiers',
      entityLink: 'hatch_competitors--entity-link',
      latestIntelFilter: 'hatch_competitors--latest-intel-filter',
      productFilter: 'hatch_competitors--product-filter',
      productFilterApply: 'hatch_competitors--product-filter-apply',
      productFilterOption: 'hatch_competitors--product-filter-option',
      productFilterReset: 'hatch_competitors--product-filter-reset',
      productLink: 'hatch_competitors--product-link',
      productsOverflow: 'hatch_competitors--products-overflow',
      productsShowHidden: 'hatch_competitors--products-show-hidden',
      productsToggle: 'hatch_competitors--products-toggle',
      resetShowAll: 'hatch_competitors--reset-show-all',
      searchClear: 'hatch_competitors--search-clear',
      searchResult: 'hatch_competitors--search-result',
      sheetClose: 'hatch_competitors--sheet-close',
      sheetEntitySwitcher: 'hatch_competitors--sheet-entity-switcher',
      sheetEntitySwitcherItem: 'hatch_competitors--sheet-entity-switcher-item',
      sheetOwnerLink: 'hatch_competitors--sheet-owner-link',
    },
    onboardingSetup: {
      confirmLandscapeCta: 'hatch_onboarding-setup--confirm-landscape-cta',
      bookLandscapeSession: 'hatch_onboarding-setup--book-landscape-session',
      reviewAnswersCta: 'hatch_onboarding-setup--review-answers-cta',
      backToSetup: 'hatch_onboarding-setup--back-to-setup',
      answerApprove: 'hatch_onboarding-setup--answer-approve',
      answerSkip: 'hatch_onboarding-setup--answer-skip',
      answerCoachOpen: 'hatch_onboarding-setup--answer-coach-open',
      answerToggleFullAnswer:
        'hatch_onboarding-setup--answer-toggle-full-answer',
      coachModalConfirm: 'hatch_onboarding-setup--coach-modal-confirm',
      coachModalCancel: 'hatch_onboarding-setup--coach-modal-cancel',
      bottomBarSkip: 'hatch_onboarding-setup--bottom-bar-skip',
      bottomBarCta: 'hatch_onboarding-setup--bottom-bar-cta',
      answersCompleteContinue:
        'hatch_onboarding-setup--answers-complete-continue',
      // Rendered outside production only, so this should never report from prod.
      answerAssignmentReset: 'hatch_onboarding-setup--answer-assignment-reset',
      coachPanel: {
        approve: 'hatch_onboarding-setup-coach-panel--approve',
        skip: 'hatch_onboarding-setup-coach-panel--skip',
        back: 'hatch_onboarding-setup-coach-panel--back',
      },
      pilotEmailAcknowledge: 'hatch_onboarding-setup--pilot-email-acknowledge',
      pilotEmailCopy: 'hatch_onboarding-setup--pilot-email-copy',
      pilotEmailSubjectCopy: 'hatch_onboarding-setup--pilot-email-subject-copy',
      pilotSellersEmailed: 'hatch_onboarding-setup--pilot-sellers-emailed',
      teamRolloutInvitePilot:
        'hatch_onboarding-setup--team-rollout-invite-pilot',
      teamRolloutFullOrg: 'hatch_onboarding-setup--team-rollout-full-org',
      wholeOrgModalCancel: 'hatch_onboarding-setup--whole-org-modal-cancel',
      wholeOrgModalConfirm: 'hatch_onboarding-setup--whole-org-modal-confirm',
      wholeOrgModalRequestInfo:
        'hatch_onboarding-setup--whole-org-modal-request-info',
    },
    artifactDrawer: {
      close: 'hatch_artifact-drawer--close',
    },
    deliverTo: {
      pillHome: 'hatch_deliver-to--pill-home',
      pillEmail: 'hatch_deliver-to--pill-email',
      pillChannel: 'hatch_deliver-to--pill-channel',
      platformSlack: 'hatch_deliver-to--platform-slack',
      platformTeams: 'hatch_deliver-to--platform-teams',
      drawerSave: 'hatch_deliver-to--drawer-save',
      drawerCancel: 'hatch_deliver-to--drawer-cancel',
      drawerClose: 'hatch_deliver-to--drawer-close',
    },
    agentArtifacts: {
      newsTile: 'hatch_agent-artifacts--news-tile',
      newsRollupTile: 'hatch_agent-artifacts--news-rollup-tile',
      quoteTile: 'hatch_agent-artifacts--quote-tile',
      prospectsQuotesRollupTile:
        'hatch_agent-artifacts--prospects-quotes-rollup-tile',
      objectionTile: 'hatch_agent-artifacts--objection-tile',
      pullQuotePlay: 'hatch_agent-artifacts--pull-quote-play',
      pullQuoteRefresh: 'hatch_agent-artifacts--pull-quote-refresh',
      pullQuoteRetry: 'hatch_agent-artifacts--pull-quote-retry',
      objectionHandlingRollupTile:
        'hatch_agent-artifacts--objection-handling-rollup-tile',
      winLossStoryTile: 'hatch_agent-artifacts--winloss-story-tile',
      homeFeedRow: 'hatch_agent-artifacts--home-feed-row',
      homeFeedGroupExpander: 'hatch_agent-artifacts--home-feed-group-expander',
      homeFeedEmptyTryWeek: 'hatch_agent-artifacts--home-feed-empty-try-week',
      detailCopyText: 'hatch_agent-artifacts--detail-copy-text',
      detailShowOriginal: 'hatch_agent-artifacts--detail-show-original',
      // Digest headline rename on the detail header (ENG-4010).
      digestTitle: {
        edit: 'hatch_agent-artifacts--digest-title-edit',
        save: 'hatch_agent-artifacts--digest-title-save',
        cancel: 'hatch_agent-artifacts--digest-title-cancel',
      },
      // Curator-authored "Our Take" — the edit mode on artifact detail.
      ourTake: {
        editModeEnter: 'hatch_agent-artifacts--our-take-edit-mode-enter',
        editModeExit: 'hatch_agent-artifacts--our-take-edit-mode-exit',
        trigger: 'hatch_agent-artifacts--our-take-trigger',
        save: 'hatch_agent-artifacts--our-take-save',
        cancel: 'hatch_agent-artifacts--our-take-cancel',
        edit: 'hatch_agent-artifacts--our-take-edit',
        editSave: 'hatch_agent-artifacts--our-take-edit-save',
        editCancel: 'hatch_agent-artifacts--our-take-edit-cancel',
        remove: 'hatch_agent-artifacts--our-take-remove',
      },
      // `finding` block: the more-quotes fold, each quote's source link, and
      // its clip (thumbnail, modal player, modal source link).
      finding: {
        quotesToggle: 'hatch_agent-artifacts--finding-quotes-toggle',
        sourceLink: 'hatch_agent-artifacts--finding-source-link',
        clipOpen: 'hatch_agent-artifacts--finding-clip-open',
        clipPlay: 'hatch_agent-artifacts--finding-clip-play',
        clipSourceLink: 'hatch_agent-artifacts--finding-clip-source-link',
      },
      // Artifact-reference editing on the digest (remove / add story).
      references: {
        addClose: 'hatch_agent-artifacts--references-add-close',
        addOpen: 'hatch_agent-artifacts--references-add-open',
        addSearch: 'hatch_agent-artifacts--references-add-search',
        addSearchClear: 'hatch_agent-artifacts--references-add-search-clear',
        addSubmit: 'hatch_agent-artifacts--references-add-submit',
        addTabs: 'hatch_agent-artifacts--references-add-tabs',
        // "Paste a link" mode (ENG-3528): submit the URL form, attach the
        // story the server says already covers that URL, pick a competitor,
        // or clear the found-story card to try another link.
        addUrlCompetitor:
          'hatch_agent-artifacts--references-add-url-competitor',
        addUrlReset: 'hatch_agent-artifacts--references-add-url-reset',
        addUrlSubmit: 'hatch_agent-artifacts--references-add-url-submit',
        addUrlUseExisting:
          'hatch_agent-artifacts--references-add-url-use-existing',
        remove: 'hatch_agent-artifacts--references-remove',
        storyRow: 'hatch_agent-artifacts--references-story-row',
        storySourceLink: 'hatch_agent-artifacts--references-story-source-link',
        takeAccept: 'hatch_agent-artifacts--references-take-accept',
        takeAdd: 'hatch_agent-artifacts--references-take-add',
        takeCancel: 'hatch_agent-artifacts--references-take-cancel',
        takeDelete: 'hatch_agent-artifacts--references-take-delete',
        takeEdit: 'hatch_agent-artifacts--references-take-edit',
        takeSave: 'hatch_agent-artifacts--references-take-save',
      },
      // Digest auto-send banner: audience popover, toggle, Send now / Skip,
      // and the post-send card's actions (ENG-3121).
      deliverySettings: {
        audienceKind: 'hatch_agent-artifacts--delivery-settings-audience-kind',
        audiencePeople:
          'hatch_agent-artifacts--delivery-settings-audience-people',
        autoSendToggle:
          'hatch_agent-artifacts--delivery-settings-auto-send-toggle',
        cancel: 'hatch_agent-artifacts--delivery-settings-cancel',
        save: 'hatch_agent-artifacts--delivery-settings-save',
        viewAllDigests:
          'hatch_agent-artifacts--delivery-settings-view-all-digests',
        slackAddChannel:
          'hatch_agent-artifacts--delivery-settings-slack-add-channel',
        slackConnectLink:
          'hatch_agent-artifacts--delivery-settings-slack-connect-link',
        slackRemoveChannel:
          'hatch_agent-artifacts--delivery-settings-slack-remove-channel',
        sendNow: 'hatch_agent-artifacts--delivery-settings-send-now',
        skip: 'hatch_agent-artifacts--delivery-settings-skip',
        trigger: 'hatch_agent-artifacts--delivery-settings-trigger',
        viewSentIssue:
          'hatch_agent-artifacts--delivery-settings-view-sent-issue',
      },
      library: {
        page: 'hatch_agent-artifacts--library-page',
        typeFilter: 'hatch_agent-artifacts--library-type-filter',
        search: 'hatch_agent-artifacts--library-search',
        searchClear: 'hatch_agent-artifacts--library-search-clear',
        competitorFilter: 'hatch_agent-artifacts--library-competitor-filter',
        listItem: 'hatch_agent-artifacts--library-list-item',
        whyThis: 'hatch_agent-artifacts--library-why-this',
        addFilter: 'hatch_agent-artifacts--library-add-filter',
        pagination: 'hatch_agent-artifacts--library-pagination',
        retry: 'hatch_agent-artifacts--library-retry',
        filterChip: {
          attribute: 'hatch_agent-artifacts--library-filter-chip-attribute',
          operator: 'hatch_agent-artifacts--library-filter-chip-operator',
          value: 'hatch_agent-artifacts--library-filter-chip-value',
          remove: 'hatch_agent-artifacts--library-filter-chip-remove',
        },
      },
      // A module tab's artifact list carries the same toolbar as the library
      // but is its own surface, so its controls get their own ids — otherwise
      // "who searched the library?" and "who searched a module?" are one
      // number.
      workspaceTab: {
        competitorFilter:
          'hatch_agent-artifacts--workspace-tab-competitor-filter',
        outcomeLost: 'hatch_agent-artifacts--workspace-tab-outcome-lost',
        outcomeWon: 'hatch_agent-artifacts--workspace-tab-outcome-won',
        retry: 'hatch_agent-artifacts--workspace-tab-retry',
        search: 'hatch_agent-artifacts--workspace-tab-search',
        searchClear: 'hatch_agent-artifacts--workspace-tab-search-clear',
      },
      // The Win/Loss stories tab is its own surface, not the generic workspace
      // tab: it has a featured row, an outcome toggle and a quarter filter that
      // no other tab has, so "did anyone use the quarter filter?" has to be
      // answerable without the generic tab's traffic drowning it.
      winLossStories: {
        competitorFilter:
          'hatch_agent-artifacts--win-loss-stories-competitor-filter',
        outcomeFilter: 'hatch_agent-artifacts--win-loss-stories-outcome-filter',
        outcomeFilterItem:
          'hatch_agent-artifacts--win-loss-stories-outcome-filter-item',
        outcomeLost: 'hatch_agent-artifacts--win-loss-stories-outcome-lost',
        outcomeWon: 'hatch_agent-artifacts--win-loss-stories-outcome-won',
        quarterFilter: 'hatch_agent-artifacts--win-loss-stories-quarter-filter',
        quarterFilterItem:
          'hatch_agent-artifacts--win-loss-stories-quarter-filter-item',
        search: 'hatch_agent-artifacts--win-loss-stories-search',
        searchClear: 'hatch_agent-artifacts--win-loss-stories-search-clear',
      },
      newsRollupDetail: {
        page: 'hatch_agent-artifacts--news-rollup-detail-page',
        allRollupsLink: 'hatch_agent-artifacts--news-rollup-detail-all-rollups',
        readStorySource:
          'hatch_agent-artifacts--news-rollup-detail-read-story-source',
        readStoryArtifact:
          'hatch_agent-artifacts--news-rollup-detail-read-story-artifact',
        share: {
          trigger: 'hatch_agent-artifacts--news-rollup-detail-share-trigger',
          copyLink: 'hatch_agent-artifacts--news-rollup-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--news-rollup-detail-share-slack',
          teams: 'hatch_agent-artifacts--news-rollup-detail-share-teams',
        },
      },
      objectionHandlingRollupDetail: {
        page: 'hatch_agent-artifacts--objection-handling-rollup-detail-page',
        allRollupsLink:
          'hatch_agent-artifacts--objection-handling-rollup-detail-all-rollups',
        share: {
          trigger:
            'hatch_agent-artifacts--objection-handling-rollup-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--objection-handling-rollup-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--objection-handling-rollup-detail-share-slack',
          teams:
            'hatch_agent-artifacts--objection-handling-rollup-detail-share-teams',
        },
      },
      prospectsQuotesRollupDetail: {
        page: 'hatch_agent-artifacts--prospects-quotes-rollup-detail-page',
        allRollupsLink:
          'hatch_agent-artifacts--prospects-quotes-rollup-detail-all-rollups',
        share: {
          trigger:
            'hatch_agent-artifacts--prospects-quotes-rollup-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--prospects-quotes-rollup-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--prospects-quotes-rollup-detail-share-slack',
          teams:
            'hatch_agent-artifacts--prospects-quotes-rollup-detail-share-teams',
        },
      },
      newsDetail: {
        page: 'hatch_agent-artifacts--news-detail-page',
        allNewsLink: 'hatch_agent-artifacts--news-detail-all-news',
        readOriginal: 'hatch_agent-artifacts--news-detail-read-original',
        share: {
          trigger: 'hatch_agent-artifacts--news-detail-share-trigger',
          copyLink: 'hatch_agent-artifacts--news-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--news-detail-share-slack',
          teams: 'hatch_agent-artifacts--news-detail-share-teams',
        },
      },
      quoteDetail: {
        page: 'hatch_agent-artifacts--quote-detail-page',
        allQuotesLink: 'hatch_agent-artifacts--quote-detail-all-quotes',
        viewSnippet: 'hatch_agent-artifacts--quote-detail-view-snippet',
        share: {
          trigger: 'hatch_agent-artifacts--quote-detail-share-trigger',
          copyLink: 'hatch_agent-artifacts--quote-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--quote-detail-share-slack',
          teams: 'hatch_agent-artifacts--quote-detail-share-teams',
        },
      },
      objectionDetail: {
        page: 'hatch_agent-artifacts--objection-detail-page',
        allObjectionsLink:
          'hatch_agent-artifacts--objection-detail-all-objections',
        viewSnippet: 'hatch_agent-artifacts--objection-detail-view-snippet',
        share: {
          trigger: 'hatch_agent-artifacts--objection-detail-share-trigger',
          copyLink: 'hatch_agent-artifacts--objection-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--objection-detail-share-slack',
          teams: 'hatch_agent-artifacts--objection-detail-share-teams',
        },
      },
      winLossStoryDetail: {
        page: 'hatch_agent-artifacts--winloss-story-detail-page',
        allStoriesLink:
          'hatch_agent-artifacts--winloss-story-detail-all-stories',
        viewDeal: 'hatch_agent-artifacts--winloss-story-detail-view-deal',
        viewSource: 'hatch_agent-artifacts--winloss-story-detail-view-source',
        share: {
          trigger: 'hatch_agent-artifacts--winloss-story-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--winloss-story-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--winloss-story-detail-share-slack',
          teams: 'hatch_agent-artifacts--winloss-story-detail-share-teams',
        },
      },
      winLossRollupDetail: {
        page: 'hatch_agent-artifacts--winloss-rollup-detail-page',
        allItemsLink: 'hatch_agent-artifacts--winloss-rollup-detail-all-items',
        share: {
          trigger: 'hatch_agent-artifacts--winloss-rollup-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--winloss-rollup-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--winloss-rollup-detail-share-slack',
          teams: 'hatch_agent-artifacts--winloss-rollup-detail-share-teams',
        },
      },
      talkTracksDetail: {
        page: 'hatch_agent-artifacts--talk-tracks-detail-page',
        allItemsLink: 'hatch_agent-artifacts--talk-tracks-detail-all-items',
        share: {
          trigger: 'hatch_agent-artifacts--talk-tracks-detail-share-trigger',
          copyLink: 'hatch_agent-artifacts--talk-tracks-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--talk-tracks-detail-share-slack',
          teams: 'hatch_agent-artifacts--talk-tracks-detail-share-teams',
        },
      },
      talkTracksRollupDetail: {
        page: 'hatch_agent-artifacts--talktracks-rollup-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--talktracks-rollup-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--talktracks-rollup-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--talktracks-rollup-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--talktracks-rollup-detail-share-slack',
          teams: 'hatch_agent-artifacts--talktracks-rollup-detail-share-teams',
        },
      },
      dailyBriefDetail: {
        page: 'hatch_agent-artifacts--daily-brief-detail-page',
        allItemsLink: 'hatch_agent-artifacts--daily-brief-detail-all-items',
        share: {
          trigger: 'hatch_agent-artifacts--daily-brief-detail-share-trigger',
          copyLink: 'hatch_agent-artifacts--daily-brief-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--daily-brief-detail-share-slack',
          teams: 'hatch_agent-artifacts--daily-brief-detail-share-teams',
        },
      },
      customerQuoteDetail: {
        page: 'hatch_agent-artifacts--customer-quote-detail-page',
        allItemsLink: 'hatch_agent-artifacts--customer-quote-detail-all-items',
        share: {
          trigger: 'hatch_agent-artifacts--customer-quote-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--customer-quote-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--customer-quote-detail-share-slack',
          teams: 'hatch_agent-artifacts--customer-quote-detail-share-teams',
        },
      },
      customerQuotesRollupDetail: {
        page: 'hatch_agent-artifacts--customer-quotes-rollup-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--customer-quotes-rollup-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--customer-quotes-rollup-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--customer-quotes-rollup-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--customer-quotes-rollup-detail-share-slack',
          teams:
            'hatch_agent-artifacts--customer-quotes-rollup-detail-share-teams',
        },
      },
      prospectQuotesRollupTopicsDetail: {
        page: 'hatch_agent-artifacts--prospect-quotes-rollup-topics-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--prospect-quotes-rollup-topics-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--prospect-quotes-rollup-topics-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--prospect-quotes-rollup-topics-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--prospect-quotes-rollup-topics-detail-share-slack',
          teams:
            'hatch_agent-artifacts--prospect-quotes-rollup-topics-detail-share-teams',
        },
      },
      objectionHandlingRollupTopicsDetail: {
        page: 'hatch_agent-artifacts--objection-handling-rollup-topics-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--objection-handling-rollup-topics-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--objection-handling-rollup-topics-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--objection-handling-rollup-topics-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--objection-handling-rollup-topics-detail-share-slack',
          teams:
            'hatch_agent-artifacts--objection-handling-rollup-topics-detail-share-teams',
        },
      },
      talkTracksRollupTopicsDetail: {
        page: 'hatch_agent-artifacts--talk-tracks-rollup-topics-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--talk-tracks-rollup-topics-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--talk-tracks-rollup-topics-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--talk-tracks-rollup-topics-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--talk-tracks-rollup-topics-detail-share-slack',
          teams:
            'hatch_agent-artifacts--talk-tracks-rollup-topics-detail-share-teams',
        },
      },
      winLossRollupTopicsDetail: {
        page: 'hatch_agent-artifacts--winloss-rollup-topics-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--winloss-rollup-topics-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--winloss-rollup-topics-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--winloss-rollup-topics-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--winloss-rollup-topics-detail-share-slack',
          teams:
            'hatch_agent-artifacts--winloss-rollup-topics-detail-share-teams',
        },
      },
      proofPointsDetail: {
        page: 'hatch_agent-artifacts--proof-points-detail-page',
        allItemsLink: 'hatch_agent-artifacts--proof-points-detail-all-items',
        share: {
          trigger: 'hatch_agent-artifacts--proof-points-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--proof-points-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--proof-points-detail-share-slack',
          teams: 'hatch_agent-artifacts--proof-points-detail-share-teams',
        },
      },
      hiringSignalDetail: {
        page: 'hatch_agent-artifacts--hiring-signal-detail-page',
        allItemsLink: 'hatch_agent-artifacts--hiring-signal-detail-all-items',
        share: {
          trigger: 'hatch_agent-artifacts--hiring-signal-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--hiring-signal-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--hiring-signal-detail-share-slack',
          teams: 'hatch_agent-artifacts--hiring-signal-detail-share-teams',
        },
      },
      blindspotsDetail: {
        page: 'hatch_agent-artifacts--blindspots-detail-page',
        allItemsLink: 'hatch_agent-artifacts--blindspots-detail-all-items',
        share: {
          trigger: 'hatch_agent-artifacts--blindspots-detail-share-trigger',
          copyLink: 'hatch_agent-artifacts--blindspots-detail-share-copy-link',
          slack: 'hatch_agent-artifacts--blindspots-detail-share-slack',
          teams: 'hatch_agent-artifacts--blindspots-detail-share-teams',
        },
      },
      campaignInterviewAnalysisDetail: {
        page: 'hatch_agent-artifacts--campaign-interview-analysis-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--campaign-interview-analysis-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--campaign-interview-analysis-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--campaign-interview-analysis-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--campaign-interview-analysis-detail-share-slack',
          teams:
            'hatch_agent-artifacts--campaign-interview-analysis-detail-share-teams',
        },
      },
      campaignRollupAnalysisDetail: {
        page: 'hatch_agent-artifacts--campaign-rollup-analysis-detail-page',
        allItemsLink:
          'hatch_agent-artifacts--campaign-rollup-analysis-detail-all-items',
        share: {
          trigger:
            'hatch_agent-artifacts--campaign-rollup-analysis-detail-share-trigger',
          copyLink:
            'hatch_agent-artifacts--campaign-rollup-analysis-detail-share-copy-link',
          slack:
            'hatch_agent-artifacts--campaign-rollup-analysis-detail-share-slack',
          teams:
            'hatch_agent-artifacts--campaign-rollup-analysis-detail-share-teams',
        },
      },
    },
    answers: {
      clearFilters: 'hatch_answers--clear-filters',
      competitorFilter: 'hatch_answers-competitor-filter--toggle',
      competitorFilterClear: 'hatch_answers-competitor-filter--clear',
      dealQuestionsSort: 'hatch_answers-deal-questions--sort',
    },
    chat: {
      answer: {
        copy: 'hatch_chat-answer--copy',
        // The two ids below predate ENG-3556, when the options were "Copy
        // text" and "Copy with sources". They now sit on "Copy rich text" and
        // "Copy markdown" respectively; the values are kept so click history
        // stays continuous.
        copyText: 'hatch_chat-answer--copy-text',
        copyWithSources: 'hatch_chat-answer--copy-with-sources',
        copyIncludeSources: 'hatch_chat-answer--copy-include-sources',
        negativeFeedback: 'hatch_chat-answer--negative-feedback',
        positiveFeedback: 'hatch_chat-answer--positive-feedback',
      },
      actionMenu: {
        trigger: 'hatch_chat-action-menu--trigger',
      },
      citation: {
        manageSnippet: 'hatch_chat-citation--manage-snippet',
      },
      coachMode: {
        close: 'hatch_chat-coach-mode--close',
        reset: 'hatch_chat-coach-mode--reset',
        toggle: 'hatch_chat-coach-mode--toggle',
      },
      followup: {
        recommendation: 'hatch_chat-followup--recommendation',
      },
      guidedFlow: {
        submit: 'hatch_chat-guided-flow--submit',
      },
      modeToggle: {
        answer: 'hatch_chat-mode-toggle--answer',
        autoDetect: 'hatch_chat-mode-toggle--auto-detect',
        build: 'hatch_chat-mode-toggle--build',
        trigger: 'hatch_chat-mode-toggle--trigger',
      },
      newChat: 'hatch_chat--new-chat',
      selectionContext: {
        clear: 'hatch_chat-selection-context--clear',
      },
      sessionFeedback: {
        yes: 'hatch_chat-session-feedback--yes',
        no: 'hatch_chat-session-feedback--no',
        skip: 'hatch_chat-session-feedback--skip',
        dismiss: 'hatch_chat-session-feedback--dismiss',
        submitComment: 'hatch_chat-session-feedback--submit-comment',
      },
      sidebar: {
        collapsedIndicator: 'hatch_chat-sidebar--collapsed-indicator',
        toggle: 'hatch_chat-sidebar--toggle',
      },
      sources: {
        filter: 'hatch_chat-sources--filter',
        showSources: 'hatch_chat-sources--show-sources',
        viewIndividual: 'hatch_chat-sources--view-individual',
      },
      submit: {
        followup: 'hatch_chat-submit--followup',
        launchpad: 'hatch_chat-submit--launchpad',
      },
      topBar: {
        createNewChat: 'hatch_chat-topbar--create-new-chat',
      },
      chatSettings: {
        trigger: 'hatch_chat-settings--trigger',
        webSearch: 'hatch_chat-settings--web-search',
        dismissWebSearch: 'hatch_chat-settings--dismiss-web-search',
        resetDefaults: 'hatch_chat-settings--reset-defaults',
      },
    },
    common: {
      errorRetry: 'hatch_common--error-retry',
      infoPanel: {
        sectionToggle: 'hatch_common-info-panel--section-toggle',
        sectionCaret: 'hatch_common-info-panel--section-caret',
      },
    },
    dealTips: {
      detail: {
        backBtn: 'hatch_deal-tips-detail--back-btn',
        dealInfo: 'hatch_deal-tips-detail--deal-info',
        emailCopy: 'hatch_deal-tips-detail--email-copy',
        emailResend: 'hatch_deal-tips-detail--email-resend',
        emailResendCancel: 'hatch_deal-tips-detail--email-resend-cancel',
        emailResendSubmit: 'hatch_deal-tips-detail--email-resend-submit',
        emailLink: 'hatch_deal-tips-detail--email-link',
        emailSnippetLink: 'hatch_deal-tips-detail--email-snippet-link',
        feedbackCancel: 'hatch_deal-tips-detail--feedback-cancel',
        feedbackSubmit: 'hatch_deal-tips-detail--feedback-submit',
        openCall: 'hatch_deal-tips-detail--open-call',
        participantCopyEmail: 'hatch_deal-tips-detail--participant-copy-email',
        participantExpand: 'hatch_deal-tips-detail--participant-expand',
        participantMenu: 'hatch_deal-tips-detail--participant-menu',
        participantTips: 'hatch_deal-tips-detail--participant-tips',
        requirementAction: 'hatch_deal-tips-detail--requirement-action',
        requirementExpand: 'hatch_deal-tips-detail--requirement-expand',
      },
      settings: {
        cancel: 'hatch_deal-tips-settings--cancel',
        save: 'hatch_deal-tips-settings--save',
        notifyToggle: 'hatch_deal-tips-settings--notify-toggle',
        agentControls: {
          amountMin: 'hatch_deal-tips-settings--agent-controls-amount-min',
          amountBlockMissing:
            'hatch_deal-tips-settings--agent-controls-amount-block-missing',
          amountToggle:
            'hatch_deal-tips-settings--agent-controls-amount-toggle',
          amountReset: 'hatch_deal-tips-settings--agent-controls-amount-reset',
          amountSave: 'hatch_deal-tips-settings--agent-controls-amount-save',
          amountCancel:
            'hatch_deal-tips-settings--agent-controls-amount-cancel',
          stageMode: 'hatch_deal-tips-settings--agent-controls-stage-mode',
          stageValues: 'hatch_deal-tips-settings--agent-controls-stage-values',
          stageBlockMissing:
            'hatch_deal-tips-settings--agent-controls-stage-block-missing',
          stageToggle: 'hatch_deal-tips-settings--agent-controls-stage-toggle',
          stageReset: 'hatch_deal-tips-settings--agent-controls-stage-reset',
          stageSave: 'hatch_deal-tips-settings--agent-controls-stage-save',
          stageCancel: 'hatch_deal-tips-settings--agent-controls-stage-cancel',
          typeMode: 'hatch_deal-tips-settings--agent-controls-type-mode',
          typeValues: 'hatch_deal-tips-settings--agent-controls-type-values',
          typeBlockMissing:
            'hatch_deal-tips-settings--agent-controls-type-block-missing',
          typeToggle: 'hatch_deal-tips-settings--agent-controls-type-toggle',
          typeReset: 'hatch_deal-tips-settings--agent-controls-type-reset',
          typeSave: 'hatch_deal-tips-settings--agent-controls-type-save',
          typeCancel: 'hatch_deal-tips-settings--agent-controls-type-cancel',
          emailMode: 'hatch_deal-tips-settings--agent-controls-email-mode',
          emailValues: 'hatch_deal-tips-settings--agent-controls-email-values',
          emailToggle: 'hatch_deal-tips-settings--agent-controls-email-toggle',
          emailReset: 'hatch_deal-tips-settings--agent-controls-email-reset',
          emailSave: 'hatch_deal-tips-settings--agent-controls-email-save',
          emailCancel: 'hatch_deal-tips-settings--agent-controls-email-cancel',
          roleMode: 'hatch_deal-tips-settings--agent-controls-role-mode',
          roleValues: 'hatch_deal-tips-settings--agent-controls-role-values',
          roleBlockMissing:
            'hatch_deal-tips-settings--agent-controls-role-block-missing',
          roleToggle: 'hatch_deal-tips-settings--agent-controls-role-toggle',
          roleReset: 'hatch_deal-tips-settings--agent-controls-role-reset',
          roleSave: 'hatch_deal-tips-settings--agent-controls-role-save',
          roleCancel: 'hatch_deal-tips-settings--agent-controls-role-cancel',
        },
      },
    },
    files: {
      deleteFile: 'hatch_files--delete-file',
      downloadFile: 'hatch_files--download-file',
      sortName: 'hatch_files--sort-name',
      sortDate: 'hatch_files--sort-date',
    },
    inbox: {
      clearFilters: 'hatch_inbox--clear-filters',
      competitorFilterItem: 'hatch_inbox-competitor-filter--item',
      dateFilterItem: 'hatch_inbox-date-filter--item',
      opportunityFilterItem: 'hatch_inbox-opportunity-filter--item',
      stageFilterItem: 'hatch_inbox-stage-filter--item',
      typeFilterItem: 'hatch_inbox-type-filter--item',
      dealTip: {
        askKlue: 'hatch_inbox-deal-tip--ask-klue',
        card: 'hatch_inbox-deal-tip--card',
        dateFilter: 'hatch_inbox-deal-tip--date-filter',
        expandSection: 'hatch_inbox-deal-tip--expand-section',
        flagCompetitor: 'hatch_inbox-deal-tip--flag-competitor',
        userFilter: 'hatch_inbox-deal-tip--user-filter',
        competitorFilter: 'hatch_inbox-deal-tip--competitor-filter',
        opportunityFilter: 'hatch_inbox-deal-tip--opportunity-filter',
        stageFilter: 'hatch_inbox-deal-tip--stage-filter',
        typeFilter: 'hatch_inbox-deal-tip--type-filter',
      },
      emptyAction: 'hatch_inbox--empty-action',
      userFilterItem: 'hatch_inbox-user-filter--item',
    },
    launchpad: {
      actionCard: 'hatch_launchpad--action-card',
      dealQuestionsPreview: {
        viewAll: 'hatch_launchpad-deal-questions-preview--view-all',
      },
      dealTipsPreview: {
        viewAll: 'hatch_launchpad-deal-tips-preview--view-all',
      },
      intelPreview: {
        dismissBanner: 'hatch_launchpad-intel-preview--dismiss-banner',
        tabDealQuestions: 'hatch_launchpad-intel-preview--tab-deal-questions',
        tabDealTips: 'hatch_launchpad-intel-preview--tab-deal-tips',
        tabMenu: 'hatch_launchpad-intel-preview--tab-menu',
      },
      quickAction: {
        actionSetSwitch: 'hatch_launchpad-quick-action--action-set-switch',
        actionSetItem: 'hatch_launchpad-quick-action--action-set-item',
        analyzeData: 'hatch_launchpad-quick-action--analyze-data',
        compareCompetitors: 'hatch_launchpad-quick-action--compare-competitors',
        findProofPoints: 'hatch_launchpad-quick-action--find-proof-points',
        getBriefing: 'hatch_launchpad-quick-action--get-briefing',
        handleObjection: 'hatch_launchpad-quick-action--handle-objection',
        researchCompetitor: 'hatch_launchpad-quick-action--research-competitor',
        shareableOnePager: 'hatch_launchpad-quick-action--shareable-one-pager',
        supportDeal: 'hatch_launchpad-quick-action--support-deal',
        validateClaim: 'hatch_launchpad-quick-action--validate-claim',
      },
      suggestedPrompts: {
        categoryPill: 'hatch_launchpad-suggested-prompts--category-pill',
        dismiss: 'hatch_launchpad-suggested-prompts--dismiss',
        promptClick: 'hatch_launchpad-suggested-prompts--prompt-click',
      },
    },
    nav: {
      back: 'hatch_nav--back',
      clearHistory: 'hatch_nav--clear-history',
      collapsedChats: 'hatch_nav-collapsed-chats--toggle',
      deleteChat: {
        cancel: 'hatch_nav-delete-chat--cancel',
        confirm: 'hatch_nav-delete-chat--confirm',
        trigger: 'hatch_nav-delete-chat--trigger',
      },
      exitImpersonation: 'hatch_nav--exit-impersonation',
      switchInstance: 'hatch_nav--switch-instance',
      forward: 'hatch_nav--forward',
      infoPanel: 'hatch_nav--info-panel',
      interviews: 'hatch_nav--interviews',
      interviewsModule: 'hatch_nav--interviews-module',
      recentVisits: 'hatch_nav--recent-visits',
      recentVisitItem: 'hatch_nav--recent-visit-item',
      sidebarCollapse: 'hatch_nav--sidebar-collapse',
      signOut: {
        cancel: 'hatch_nav-sign-out--cancel',
        confirm: 'hatch_nav-sign-out--confirm',
      },
      userMenu: 'hatch_nav--user-menu',
    },
    sessionChanged: {
      reloadLater: 'hatch_session-changed--reload-later',
      reloadNow: 'hatch_session-changed--reload-now',
    },
    sessionTimeout: {
      idle: 'hatch_session-timeout--stay-connected',
      absolute: 'hatch_session-timeout--sign-in-again',
    },
    recoveryRequests: {
      review: 'hatch_recovery-requests--review',
    },
    onboarding: {
      continueBtn: 'hatch_onboarding--continue',
    },
    pairwiseReviews: {
      assignmentCard: 'hatch_pairwise-reviews--assignment-card',
      reviewAgain: 'hatch_pairwise-reviews--review-again',
      selectionLeft: 'hatch_pairwise-reviews--selection-left',
      selectionRight: 'hatch_pairwise-reviews--selection-right',
      selectionNeither: 'hatch_pairwise-reviews--selection-neither',
      submitVote: 'hatch_pairwise-reviews--submit-vote',
    },
    settings: {
      channelSync: {
        autoAnswerToggle: 'hatch_settings-channel-sync--auto-answer-toggle',
        back: 'hatch_settings-channel-sync--back',
        cancel: 'hatch_settings-channel-sync--cancel',
        headerAction: 'hatch_settings-channel-sync--header-action',
        rowCheckbox: 'hatch_settings-channel-sync--row-checkbox',
        save: 'hatch_settings-channel-sync--save',
        selectAll: 'hatch_settings-channel-sync--select-all',
        selectNone: 'hatch_settings-channel-sync--select-none',
      },
      battlecardInstructions: {
        entry: 'hatch_settings-battlecard-instructions--entry',
        sectionEntry: 'hatch_settings-battlecard-instructions--section-entry',
        backToBattlecards:
          'hatch_settings-battlecard-instructions--back-to-battlecards',
        section: 'hatch_settings-battlecard-instructions--section',
        content: 'hatch_settings-battlecard-instructions--content',
        save: 'hatch_settings-battlecard-instructions--save',
        cancel: 'hatch_settings-battlecard-instructions--cancel',
        reset: 'hatch_settings-battlecard-instructions--reset',
        confirm: 'hatch_settings-battlecard-instructions--confirm',
        dismiss: 'hatch_settings-battlecard-instructions--dismiss',
        retry: 'hatch_settings-battlecard-instructions--retry',
      },
      chatInstructions: {
        cancel: 'hatch_settings-chat-instructions--cancel',
        chatTone: 'hatch_settings-chat-instructions--chat-tone',
        salesMethodology: 'hatch_settings-chat-instructions--sales-methodology',
        save: 'hatch_settings-chat-instructions--save',
        styleGuidance: 'hatch_settings-chat-instructions--style-guidance',
      },
      competitorMap: {
        addCompetitor: 'settings_competitor-map--add-competitor',
        addOwnProduct: 'settings_competitor-map--add-own-product',
        addProduct: 'settings_competitor-map--add-product',
        approve: {
          cancel: 'settings_competitor-map-approve--cancel',
          confirm: 'settings_competitor-map-approve--confirm',
          finalize: 'settings_competitor-map--approve-finalize',
        },
        backToCompetitors: 'settings_competitor-map--back-to-competitors',
        bulk: {
          apply: 'settings_competitor-map-bulk--apply',
          cancel: 'settings_competitor-map-bulk--cancel',
          checkbox: 'settings_competitor-map-bulk--checkbox',
          clearSelection: 'settings_competitor-map-bulk--clear-selection',
          confirm: 'settings_competitor-map-bulk--confirm',
          enter: 'settings_competitor-map-bulk--enter',
          goBack: 'settings_competitor-map-bulk--go-back',
          tierClear: 'settings_competitor-map-bulk--tier-clear',
          tierOption: 'settings_competitor-map-bulk--tier-option',
          tierSelect: 'settings_competitor-map-bulk--tier-select',
        },
        changeRequestCancel: 'settings_competitor-map-change-request--cancel',
        changeRequestSubmit: 'settings_competitor-map-change-request--submit',
        competitorTile: 'settings_competitor-map--competitor-tile',
        competitorUrl: 'settings_competitor-map--competitor-url',
        entityMenu: {
          addProduct: 'settings_competitor-map-entity-menu--add-product',
          delete: 'settings_competitor-map-entity-menu--delete',
          editCompetition:
            'settings_competitor-map-entity-menu--edit-competition',
          rename: 'settings_competitor-map-entity-menu--rename',
          trigger: 'settings_competitor-map-entity-menu--trigger',
        },
        helpLink: 'settings_competitor-map--help-link',
        matchup: {
          deleteProduct: 'settings_competitor-map-matchup--delete-product',
          drawConnection: 'settings_competitor-map-matchup--draw-connection',
          editProduct: 'settings_competitor-map-matchup--edit-product',
          removeMapping: 'settings_competitor-map-matchup--remove-mapping',
          zoomIn: 'settings_competitor-map-matchup--zoom-in',
          zoomOut: 'settings_competitor-map-matchup--zoom-out',
          zoomReset: 'settings_competitor-map-matchup--zoom-reset',
        },
        remove: {
          cancel: 'settings_competitor-map-remove--cancel',
          competitor: 'settings_competitor-map-remove--competitor',
          competitorProduct:
            'settings_competitor-map-remove--competitor-product',
          competitorTile: 'settings_competitor-map-remove--competitor-tile',
          confirm: 'settings_competitor-map-remove--confirm',
          matchup: 'settings_competitor-map-remove--matchup',
          ownProduct: 'settings_competitor-map-remove--own-product',
        },
        requestChange: 'settings_competitor-map--request-change',
        tab: {
          competitors: 'settings_competitor-map--tab-competitors',
          products: 'settings_competitor-map--tab-products',
        },
        tierClear: 'settings_competitor-map--tier-clear',
        tierOption: 'settings_competitor-map--tier-option',
        tierSelect: 'settings_competitor-map--tier-select',
      },
      experiments: {
        createButton: 'hatch_settings-experiments--create-button',
        experimentCard: 'hatch_settings-experiments--experiment-card',
        actionsMenu: 'hatch_settings-experiments--actions-menu',
        editAction: 'hatch_settings-experiments--edit-action',
        deleteAction: 'hatch_settings-experiments--delete-action',
        shareAction: 'hatch_settings-experiments--share-action',
        backButton: 'hatch_settings-experiments--back-button',
        serviceUnavailableRetry:
          'hatch_settings-experiments--service-unavailable-retry',
        serviceUnavailableStatusLink:
          'hatch_settings-experiments--service-unavailable-status-link',
        form: {
          datasetUpload: 'hatch_settings-experiments-form--dataset-upload',
          datasetRemove: 'hatch_settings-experiments-form--dataset-remove',
          reviewers: 'hatch_settings-experiments-form--reviewers',
          cancel: 'hatch_settings-experiments-form--cancel',
          submit: 'hatch_settings-experiments-form--submit',
        },
      },
      sources: {
        sourceToggle: 'hatch_settings-sources--source-toggle',
        switchToggle: 'hatch_settings-sources--switch-toggle',
        helpLink: 'hatch_settings-sources--help-link',
      },
      sso: {
        authMethodCheckbox: 'hatch_settings-sso--auth-method-checkbox',
        certAction: 'hatch_settings-sso--cert-action',
        certDelete: 'hatch_settings-sso--cert-delete',
        configCheckbox: 'hatch_settings-sso--config-checkbox',
        deactivateCancel: 'hatch_settings-sso--deactivate-cancel',
        deactivateConfirm: 'hatch_settings-sso--deactivate-confirm',
        deleteCancel: 'hatch_settings-sso--delete-cancel',
        deleteConfirm: 'hatch_settings-sso--delete-confirm',
        idpModalAction: 'hatch_settings-sso--idp-modal-action',
        idpModalTab: 'hatch_settings-sso--idp-modal-tab',
        logoUpload: 'hatch_settings-sso--logo-upload',
        providerAction: 'hatch_settings-sso--provider-action',
        providerRowAction: 'hatch_settings-sso--provider-row-action',
        reactivateCancel: 'hatch_settings-sso--reactivate-cancel',
        reactivateConfirm: 'hatch_settings-sso--reactivate-confirm',
        readOnlyCopy: 'hatch_settings-sso--read-only-copy',
        refreshBtn: 'hatch_settings-sso--refresh-btn',
        sectionAction: 'hatch_settings-sso--section-action',
        sessionLimitsDefaults: 'hatch_settings-sso--session-limits-defaults',
        testLoginAction: 'hatch_settings-sso--test-login-action',
      },
      users: {
        inviteRoleDropdown: 'hatch_settings-users--invite-role-dropdown',
        inviteUser: 'hatch_settings-users--invite-user',
      },
    },
    sideNav: {
      chatHistory: {
        item: 'hatch_sidenav-chat-history--item',
      },
      tab: {
        account: 'hatch_sidenav-tab--account',
        analytics: 'hatch_sidenav-tab--analytics',
        createNewChat: 'hatch_sidenav-tab--create-new-chat',
        customerProofLibrary: 'hatch_sidenav-tab--customer-proof-library',
        help: 'hatch_sidenav-tab--help',
        labsApp: 'hatch_sidenav-tab--labs-app',
        library: 'hatch_sidenav-tab--library',
        onboardingSetup: 'hatch_sidenav-tab--onboarding-setup',
        pairwiseReviews: 'hatch_sidenav-tab--pairwise-reviews',
        settings: 'hatch_sidenav-tab--settings',
        signOut: 'hatch_sidenav-tab--sign-out',
      },
    },
    snippets: {
      alertLink: 'hatch_snippets-alert--link',
      create: 'hatch_snippets--create',
      delete: 'hatch_snippets--delete',
      editAction: 'hatch_snippets--edit-action',
      save: 'hatch_snippets--save',
      searchClear: 'hatch_snippets--search-clear',
    },
    updates: {
      emptyReviewSettings: 'hatch_updates--empty-review-settings',
      openReviewSettings: 'hatch_updates--open-review-settings',
      assigneeFilter: 'hatch_updates--assignee-filter',
      clearAllFilters: 'hatch_updates--clear-all-filters',
      clearAssigneeFilter: 'hatch_updates--clear-assignee-filter',
      clearCompetitorFilter: 'hatch_updates--clear-competitor-filter',
      clearFilters: 'hatch_updates--clear-filters',
      clearTierFilter: 'hatch_updates--clear-tier-filter',
      competitorFilter: 'hatch_updates--competitor-filter',
      showAllItems: 'hatch_updates--show-all-items',
      sortFilter: 'hatch_updates--sort-filter',
      tierFilter: 'hatch_updates--tier-filter',
      review: {
        cancelManualEdit: 'hatch_updates-review--cancel-manual-edit',
        cancelRevision: 'hatch_updates-review--cancel-revision',
        close: 'hatch_updates-review--close',
        closeDiffs: 'hatch_updates-review--close-diffs',
        manualEdit: 'hatch_updates-review--manual-edit',
        modify: 'hatch_updates-review--modify',
        nextUpdate: 'hatch_updates-review--next-update',
        previousUpdate: 'hatch_updates-review--previous-update',
        retryFeedback: 'hatch_updates-review--retry-feedback',
        saveManualEdit: 'hatch_updates-review--save-manual-edit',
        scrim: 'hatch_updates-review--scrim',
        sendBack: 'hatch_updates-review--send-back',
        sendFeedback: 'hatch_updates-review--send-feedback',
        stopFeedback: 'hatch_updates-review--stop-feedback',
        toggleDiffFold: 'hatch_updates-review--toggle-diff-fold',
        toggleDiffs: 'hatch_updates-review--toggle-diffs',
      },
      reviewSettings: {
        anyAdmin: 'hatch_updates-review-settings--any-admin',
        back: 'hatch_updates-review-settings--back',
        expand: 'hatch_updates-review-settings--expand',
        goToCompetitors: 'hatch_updates-review-settings--go-to-competitors',
        removeChip: 'hatch_updates-review-settings--remove-chip',
        selectAll: 'hatch_updates-review-settings--select-all',
        selectRow: 'hatch_updates-review-settings--select-row',
        toggleReview: 'hatch_updates-review-settings--toggle-review',
        toggleReviewer: 'hatch_updates-review-settings--toggle-reviewer',
      },
    },
    userManagement: {
      bulkCheckbox: 'hatch_user-management--bulk-checkbox',
      emailLink: 'hatch_user-management--email-link',
      inviteClose: 'hatch_user-management--invite-close',
      inviteReactivate: 'hatch_user-management--invite-reactivate',
      inviteReactivateAll: 'hatch_user-management--invite-reactivate-all',
      inviteRemoveRow: 'hatch_user-management--invite-remove-row',
      inviteRetry: 'hatch_user-management--invite-retry',
      inviteResultClose: 'hatch_user-management--invite-result-close',
      inviteSubmit: 'hatch_user-management--invite-submit',
      rowCheckbox: 'hatch_user-management--row-checkbox',
      rowMenuAction: 'hatch_user-management--row-menu-action',
      rowMenuTrigger: 'hatch_user-management--row-menu-trigger',
      sendPasswordResetEmail:
        'hatch_user-management--send-password-reset-email',
      signOutEverywhere: {
        trigger: 'hatch_user-management-sign-out-everywhere--trigger',
        confirm: 'hatch_user-management-sign-out-everywhere--confirm',
        cancel: 'hatch_user-management-sign-out-everywhere--cancel',
      },
      userEmail: 'hatch_user-management--user-email',
    },
    users: {
      emailLink: 'hatch_users--email-link',
    },
    winLossCampaigns: {
      campaignDelete: {
        trigger: 'hatch_win-loss-campaigns-campaign-delete--trigger',
        confirm: 'hatch_win-loss-campaigns-campaign-delete--confirm',
        cancel: 'hatch_win-loss-campaigns-campaign-delete--cancel',
      },
      ruleRow: 'hatch_win-loss-campaigns--rule-row',
      ruleActionsMenu: 'hatch_win-loss-campaigns--rule-actions-menu',
      ruleDeleteAction: 'hatch_win-loss-campaigns--rule-delete-action',
      createRuleButton: 'hatch_win-loss-campaigns--create-rule-button',
      ruleEditButton: 'hatch_win-loss-campaigns-rule-detail--edit-button',
      detailBackButton: 'hatch_win-loss-campaigns-detail--back-button',
      editButton: 'hatch_win-loss-campaigns-detail--edit-button',
      previewUrlCopy: 'hatch_win-loss-campaigns-detail--preview-url-copy',
      previewUrlLink: 'hatch_win-loss-campaigns-detail--preview-url-link',
      invitation: {
        request:
          'hatch_win-loss-campaigns-matched-opportunity--request-invitation',
        link: 'hatch_win-loss-campaigns-matched-opportunity--invitation-link',
        copy: 'hatch_win-loss-campaigns-matched-opportunity--copy-invitation',
      },
      rulesEditor: {
        ruleSelect: 'hatch_win-loss-campaigns-rules-editor--rule-select',
        linkTypeToggle:
          'hatch_win-loss-campaigns-rules-editor--link-type-toggle',
        addRule: 'hatch_win-loss-campaigns-rules-editor--add-rule',
        removeRule: 'hatch_win-loss-campaigns-rules-editor--remove-rule',
        createRule: 'hatch_win-loss-campaigns-rules-editor--create-rule',
      },
      companySettings: {
        displayNameInput:
          'hatch_win-loss-campaigns-company-settings--display-name-input',
        saveDisplayName:
          'hatch_win-loss-campaigns-company-settings--save-display-name',
        resetDisplayName:
          'hatch_win-loss-campaigns-company-settings--reset-display-name',
        coolOffDaysInput:
          'hatch_win-loss-campaigns-company-settings--cool-off-days-input',
        saveCoolOffDays:
          'hatch_win-loss-campaigns-company-settings--save-cool-off-days',
      },
      contactRules: {
        row: 'hatch_win-loss-campaigns--contact-rule-row',
        createButton: 'hatch_win-loss-campaigns--create-contact-rule-button',
        editButton: 'hatch_win-loss-campaigns-contact-rule-detail--edit-button',
        actionsMenu: 'hatch_win-loss-campaigns--contact-rule-actions-menu',
        deleteAction: 'hatch_win-loss-campaigns--contact-rule-delete-action',
      },
      contactRulesEditor: {
        ruleSelect:
          'hatch_win-loss-campaigns-contact-rules-editor--rule-select',
        linkTypeToggle:
          'hatch_win-loss-campaigns-contact-rules-editor--link-type-toggle',
        addRule: 'hatch_win-loss-campaigns-contact-rules-editor--add-rule',
        removeRule:
          'hatch_win-loss-campaigns-contact-rules-editor--remove-rule',
        createRule:
          'hatch_win-loss-campaigns-contact-rules-editor--create-rule',
      },
      createModal: {
        cancel: 'hatch_win-loss-campaigns-create-modal--cancel',
        submit: 'hatch_win-loss-campaigns-create-modal--submit',
        close: 'hatch_win-loss-campaigns-create-modal--close',
        templateSelect:
          'hatch_win-loss-campaigns-create-modal--template-select',
        templateCard: 'hatch_win-loss-campaigns-create-modal--template-card',
      },
      statusPage: {
        activate: 'hatch_win-loss-campaigns-status--activate',
        pause: 'hatch_win-loss-campaigns-status--pause',
        editName: 'hatch_win-loss-campaigns-status--edit-name',
        nameInput: 'hatch_win-loss-campaigns-status--name-input',
        saveName: 'hatch_win-loss-campaigns-status--save-name',
        cancelName: 'hatch_win-loss-campaigns-status--cancel-name',
        researchGoalsLink:
          'hatch_win-loss-campaigns-status--research-goals-link',
        opportunitiesLink:
          'hatch_win-loss-campaigns-status--opportunities-link',
        toggleResearchGoals:
          'hatch_win-loss-campaigns-status--toggle-research-goals',
        toggleOpportunities:
          'hatch_win-loss-campaigns-status--toggle-opportunities',
        toggleOutreach: 'hatch_win-loss-campaigns-status--toggle-outreach',
        toggleOutreachPreview:
          'hatch_win-loss-campaigns-status--toggle-outreach-preview',
        toggleGuardrails: 'hatch_win-loss-campaigns-status--toggle-guardrails',
        togglePreview: 'hatch_win-loss-campaigns-status--toggle-preview',
        scrollToTop: 'hatch_win-loss-campaigns-status--scroll-to-top',
        toggleDeliverables:
          'hatch_win-loss-campaigns-status--toggle-deliverables',
        retrospectiveSelect:
          'hatch_win-loss-campaigns-status--retrospective-select',
        saveRetrospective:
          'hatch_win-loss-campaigns-status--save-retrospective',
        outreachIncentiveInput:
          'hatch_win-loss-campaigns-status--outreach-incentive-input',
        outreachPauseAfterInput:
          'hatch_win-loss-campaigns-status--outreach-pause-after-input',
        saveOutreachConfig:
          'hatch_win-loss-campaigns-status--save-outreach-config',
        openOpportunitiesGuardrail:
          'hatch_win-loss-campaigns-status--open-opportunities-guardrail',
        gdprConsentGuardrail:
          'hatch_win-loss-campaigns-status--gdpr-consent-guardrail',
        saveGuardrails: 'hatch_win-loss-campaigns-status--save-guardrails',
      },
      researchGoalsPage: {
        goalInput: 'hatch_win-loss-campaigns-research-goals--goal-input',
        addGoal: 'hatch_win-loss-campaigns-research-goals--add-goal',
        removeGoal: 'hatch_win-loss-campaigns-research-goals--remove-goal',
        save: 'hatch_win-loss-campaigns-research-goals--save',
        cancel: 'hatch_win-loss-campaigns-research-goals--cancel',
      },
      researchLibrary: {
        search: 'hatch_win-loss-campaigns-research-library--search',
        add: 'hatch_win-loss-campaigns-research-library--add',
        done: 'hatch_win-loss-campaigns-research-library--done',
        close: 'hatch_win-loss-campaigns-research-library--close',
        categoryFilter:
          'hatch_win-loss-campaigns-research-library--category-filter',
      },
      opportunitiesPage: {
        save: 'hatch_win-loss-campaigns-opportunities--save',
        cancel: 'hatch_win-loss-campaigns-opportunities--cancel',
      },
      rulePreview: {
        run: 'hatch_win-loss-campaigns-rule-preview--run',
        loadMore: 'hatch_win-loss-campaigns-rule-preview--load-more',
      },
      contactRulePreview: {
        run: 'hatch_win-loss-campaigns-contact-rule-preview--run',
        loadMore: 'hatch_win-loss-campaigns-contact-rule-preview--load-more',
        toggleMatch:
          'hatch_win-loss-campaigns-contact-rule-preview--toggle-match',
        copyId: 'hatch_win-loss-campaigns-contact-rule-preview--copy-id',
      },
      campaignPreview: {
        run: 'hatch_win-loss-campaigns-campaign-preview--run',
        loadMore: 'hatch_win-loss-campaigns-campaign-preview--load-more',
        toggleMatch: 'hatch_win-loss-campaigns-campaign-preview--toggle-match',
        copyId: 'hatch_win-loss-campaigns-campaign-preview--copy-id',
      },
      ruleBuilder: {
        nameInput: 'hatch_win-loss-campaigns-rule-builder--name-input',
        addCondition: 'hatch_win-loss-campaigns-rule-builder--add-condition',
        addGroup: 'hatch_win-loss-campaigns-rule-builder--add-group',
        clearValues: 'hatch_win-loss-campaigns-rule-builder--clear-values',
        removeNode: 'hatch_win-loss-campaigns-rule-builder--remove-node',
        conjunctionToggle:
          'hatch_win-loss-campaigns-rule-builder--conjunction-toggle',
        emptyValueToggle:
          'hatch_win-loss-campaigns-rule-builder--empty-value-toggle',
        submit: 'hatch_win-loss-campaigns-rule-builder--submit',
        cancel: 'hatch_win-loss-campaigns-rule-builder--cancel',
      },
    },
    winLossInterviews: {
      campaignFilter: 'hatch_win-loss-interviews--campaign-filter',
      campaignFilterItem: 'hatch_win-loss-interviews--campaign-filter-item',
      competitorFilter: 'hatch_win-loss-interviews--competitor-filter',
      outcomeFilter: 'hatch_win-loss-interviews--outcome-filter',
      outcomeFilterItem: 'hatch_win-loss-interviews--outcome-filter-item',
      retry: 'hatch_win-loss-interviews--retry',
      row: 'hatch_win-loss-interviews--row',
      search: 'hatch_win-loss-interviews--search',
      searchClear: 'hatch_win-loss-interviews--search-clear',
    },
    winLossHome: {
      row: 'hatch_win-loss-home--row',
      createCampaignButton: 'hatch_win-loss-home--create-campaign-button',
      kindFilter: 'hatch_win-loss-home--kind-filter',
      kindFilterItem: 'hatch_win-loss-home--kind-filter-item',
      statusFilter: 'hatch_win-loss-home--status-filter',
      statusFilterItem: 'hatch_win-loss-home--status-filter-item',
      search: 'hatch_win-loss-home--search',
      searchClear: 'hatch_win-loss-home--search-clear',
      backButton: 'hatch_win-loss-home-detail--back-button',
      settingsButton: 'hatch_win-loss-home-detail--settings-button',
    },
    smartAnswersInspect: {
      answersListLink: 'hatch_smart-answers-inspect--answers-list-link',
      tab: {
        inspect: 'hatch_smart-answers-inspect-tab--inspect',
        inProgress: 'hatch_smart-answers-inspect-tab--in-progress',
      },
      findBox: {
        questionRow: 'hatch_smart-answers-inspect-find-box--question-row',
        addQuestion: 'hatch_smart-answers-inspect-find-box--add-question',
        cancelAdd: 'hatch_smart-answers-inspect-find-box--cancel-add',
        competitorSelect:
          'hatch_smart-answers-inspect-find-box--competitor-select',
      },
      suggestedPreviews: {
        questionRow:
          'hatch_smart-answers-inspect-suggested-previews--question-row',
        previewBtn:
          'hatch_smart-answers-inspect-suggested-previews--preview-btn',
        seeMore: 'hatch_smart-answers-inspect-suggested-previews--see-more',
      },
      adminAdded: {
        questionRow: 'hatch_smart-answers-inspect-admin-added--question-row',
      },
      questionsUsersAsked: {
        filterBadge:
          'hatch_smart-answers-inspect-questions-asked--filter-badge',
        questionRow:
          'hatch_smart-answers-inspect-questions-asked--question-row',
        prevPage: 'hatch_smart-answers-inspect-questions-asked--prev-page',
        nextPage: 'hatch_smart-answers-inspect-questions-asked--next-page',
      },
      previewDetail: {
        back: 'hatch_smart-answers-inspect-preview-detail--back',
        goodAnswer: 'hatch_smart-answers-inspect-preview-detail--good-answer',
        viewAnother: 'hatch_smart-answers-inspect-preview-detail--view-another',
        improve: 'hatch_smart-answers-inspect-preview-detail--improve',
      },
    },
  },
  sfdcWidget: {
    stockAnswer: 'sfdc-widget_stock-answer--click',
    askKlueHeader: 'sfdc-widget_ask-klue--picker-header',
    competitorCard: 'sfdc-widget_competitor--card',
    competitorPicker: {
      search: 'sfdc-widget_competitor-picker--search',
    },
    askKlue: 'sfdc-widget_ask-klue--open',
    askKlueEmpty: 'sfdc-widget_ask-klue--empty-state',
    smartAnswer: 'sfdc-widget_smart-answer--click',
    askSomethingElse: 'sfdc-widget_ask-something-else--open',
  },
  knowledgeHub: {
    checklist: {
      callToAction: 'knowledge-hub_checklist--call-to-action',
      link: 'knowledge-hub_checklist--link',
    },
    variables: {
      doneButton: 'knowledge-hub_variables_done-button',
      removeVariableButton: 'knowledge-hub_variables_remove-variable-button',
    },
    files: {
      deleteFile: 'knowledge-hub_files_delete-file',
      doneButton: 'knowledge-hub_files_done-button',
      downloadFile: 'knowledge-hub_files_download-file',
    },
    products: {
      doneButton: 'knowledge-hub_products_done-button',
      list: {
        addProductButton: 'knowledge-hub_products_list_add-product-button',
        item: {
          name: 'knowledge-hub_products_list_item_name',
          nameInput: 'knowledge-hub_products_list_item_name-input',
        },
      },
    },
    competitors: {
      doneButton: 'knowledge-hub_competitors_done-button',
      addProductButton: 'knowledge-hub_competitors_add-product-button',
      nameInput: 'knowledge-hub_competitors_name-input',
    },
    done: {
      link: 'knowledge-hub_done--back-to-dashboard-link',
    },
    widget: {
      button: 'knowledge-hub_widget--button',
    },
    error: {
      reloadButton: 'knowledge-hub_error--reload-button',
      contactSupportLink: 'knowledge-hub_error--contact-support-link',
      retryButton: 'knowledge-hub_error--retry-button',
    },
  },
  integrations: {
    accessTokens: {
      backButtonFromCreate:
        'integrations_access-tokens_back-button-from-create',
      backButtonFromRevoke:
        'integrations_access-tokens_back-button-from-revoke',
      backButtonFromView: 'integrations_access-tokens_back-button-from-view',
      copyTokenButton: 'integrations_access-tokens_copy-token-button',
      openCreateView: 'integrations_access-tokens_open-create-view',
      openRevokeView: 'integrations_access-tokens_open-revoke-view',
      revokeTokenButton: 'integrations_access-tokens_revoke-token-button',
      saveTokenButton: 'integrations_access-tokens_save-token-button',
      tokenDescriptionInput:
        'integrations_access-tokens_token-description-input',
    },
    auth: {
      addButton: 'integrations_auth_add-button',
      editButton: 'integrations_auth_edit-button',
      connectButton: 'integrations_auth_connect-button',
      reconnectButton: 'integrations_auth_reconnect-button',
      apiKeyButton: 'integrations_auth_api-key-button',
      apiKeySubmitButton: 'integrations_auth_api-key-submit-button',
    },
    closeUninstallDialog: (slug: string) =>
      `integrations_close-uninstall-dialog--${slug}`,
    configureButton: (slug: string) => `integrations_configure--${slug}`,
    connectedApps: {
      manageLink: 'integrations_connected-apps--manage-link',
    },
    gongCallInsights: {
      reloadButton: 'integrations_gong-call-insights_reload-button',
    },
    helpUrl: (slug: string) => `integrations_help-url--${slug}`,
    menuButton: (slug: string) => `integrations_menu-button--${slug}`,
    openUninstallDialog: (slug: string) =>
      `integrations_open-uninstall-dialog--${slug}`,
    primaryButton: (slug: string) => `integrations_get-button--${slug}`,
    mcpSetup: {
      openWizard: 'integrations_mcp-setup--open-wizard',
      closeModal: 'integrations_mcp-setup--close-modal',
      clientClaudeAi: 'integrations_mcp-setup--client-claude-ai',
      clientChatGpt: 'integrations_mcp-setup--client-chatgpt',
      clientClaudeDesktop: 'integrations_mcp-setup--client-claude-desktop',
      clientCustom: 'integrations_mcp-setup--client-custom',
      backToClientSelection: 'integrations_mcp-setup--back-to-client-selection',
      copyEndpoint: 'integrations_mcp-setup--copy-endpoint',
      copySnippet: 'integrations_mcp-setup--copy-snippet',
      generateKey: 'integrations_mcp-setup--generate-key',
      useExistingKey: 'integrations_mcp-setup--use-existing-key',
      manageKeys: 'integrations_mcp-setup--manage-keys',
      switchToApiKey: 'integrations_mcp-setup--switch-to-api-key',
      openClaudeAiOAuthFromDesktopPat:
        'integrations_mcp-setup--open-claude-ai-oauth-from-desktop-pat',
      backFromCreateKeyFlow:
        'integrations_mcp-setup--back-from-create-key-flow',
      pasteKeyInput: 'integrations_mcp-setup--paste-key-input',
      cancelPasteKey: 'integrations_mcp-setup--cancel-paste-key',
      applyPastedKey: 'integrations_mcp-setup--apply-pasted-key',
    },
    sections: {
      api: 'api_section',
      featured: 'featured_section',
      mcpApiWebhooks: 'integrations_section--mcp-api-webhooks',
    },
    statusButton: (slug: string) => `integrations_status--${slug}`,
    toggleButton: (slug: string) => `integrations_toggle--${slug}`,
    uninstallButton: (slug: string) => `integrations_uninstall--${slug}`,
    waitlistButton: (slug: string) => `integrations_waitlist--${slug}`,
  },
  monitors: {
    card: {
      collapse: 'monitors_card--collapse',
      expand: 'monitors_card--expand',
      externalLink: 'monitors_card--external-link',
      highlights: {
        left: {
          select: 'monitors_card--highlights-left-select',
          selectItem: 'monitors_card--highlights-left-select-item',
        },
        right: {
          select: 'monitors_card--highlights-right-select',
          selectItem: 'monitors_card--highlights-right-select-item',
        },
      },
      imageTab: {
        button: 'monitors_card--image-tab-button',
      },
      textTab: {
        button: 'monitors_card--text-tab-button',
        disableChangesOnly: 'monitors_card--text-tab-disable-changes-only',
        enableChangesOnly: 'monitors_card--text-tab-enable-changes-only',
      },
      relatedBoards: {
        addBoardItem: 'monitors-related-boards--add-board-item',
        addBoardMenu: 'monitors-related-boards--add-board-menu',
        board: 'monitors-related-boards--board',
        filter: 'monitors-related-boards--filter',
        remove: 'monitors-related-boards--remove',
        viewBoard: 'monitors-related-boards--view-board',
      },
      titleCollapse: 'monitors_card--title-collapse',
      titleExpand: 'monitors_card--title-expand',
    },
    pagination: {
      container: 'monitors_pagination--container',
    },
    topBar: {
      clearFiltersButton: 'monitors_top-bar--clear-filters-button',
      filters: {
        allBoards: {
          boardGroups: {
            tab: 'monitors_top-bar--filters-board-groups-tab',
          },
          boards: {
            prefix: 'monitors_top-bar--filters-boards-board',
            tab: 'monitors_top-bar--filters-boards-tab',
          },
          button: 'monitors_top-bar--filters-all-boards-button',
          myBoards: {
            tab: 'monitors_top-bar--filters-my-boards-tab',
          },
          search: 'monitors_top-bar--filters-all-boards-search',
          selectAll: 'monitors_top-bar--filters-all-boards-select-all',
          sort: 'monitors_top-bar--filters-all-boards-sort',
        },
        monitorSort: {
          button: 'monitors_top-bar--filters-sort-button',
          prefix: 'monitors_top-bar--filters-sort-item',
          sort: 'monitors_top-bar--filters-sort-sort',
        },
      },
      showAllButton: 'monitors_top-bar--show-all-button',
      showLessButton: 'monitors_top-bar--show-less-button',
    },
  },
  profile: {
    battlecard: {
      layoutDrop: {
        button: 'profile_battlecard-layout-drop--button',
        option: 'profile_battlecard-layout-drop--radio--option',
        radioGroup: 'profile_battlecard-layout-drop--radio-group',
      },
      print: 'profile_battlecard--print',
      reviewer: 'profile_battlecard--reviewer',
      markAsReviewed: 'profile_battlecard--mark-as-reviewed',
      stacker: {
        cardItem: 'profile_battlecard--stacker_cardItem',
      },
      edit: {
        save: 'profile_battlecard--edit-save',
        layout: {
          radioGroup: 'profile_battlecard--edit-layout-radio-group',
        },
      },
    },
    boardActionMenu: {
      bam: 'profile_board-action-menu--bam',
      collapsedView: 'profile_board-action-menu--reorder-cards',
      manageAlerts: 'profile_board-action-menu--manage-alerts',
      manageBattleCards: 'profile_board-action-menu--manage-battle-cards',
      manageLanes: 'profile_board-action-menu--manage-lanes',
      manageMonitors: 'profile_board-action-menu--manage-monitors',
      bulkActions: 'profile_board-action-menu--bulk-action',
      settings: 'profile_board-action-menu--settings',
      clone: 'profile_board-action-menu--clone',
    },
    bulkedit: {
      selectAllBoard: 'profile_bulkedit--select-all-board',
      selectAllLane: 'profile_bulkedit--select-all-lane',
    },
    lane: {
      addCard: 'profile_lane--add-card',
      addLane: 'profile_lane--add-lane',
    },
    settings: {
      curratorAssignmentDrop: 'profile_settings--currator-assignment-drop',
      groupAssignmentDrop: 'profile_settings--group-assignment-drop',
    },
    sideNav: {
      battlecardDrop: {
        button: 'profile_side-nav-battlecard-drop--button',
        item: 'profile_side-nav-battlecard-drop--item',
      },
      collapseArrow: 'profile_side-nav--collapse-arrow',
      contentHeader: 'profile_side-nav--content-header',
      key: 'profile_side-nav',
      topicsDrop: {
        button: 'profile_side-nav-topics-drop--button',
      },
    },
    subNav: {
      createAIBattlecard: 'profile_sub-nav-create-ai-battlecard',
      createAIBattlecardConfigModal: {
        cancel: 'profile_sub-nav-create-ai-battlecard--config-modal-cancel',
        generate: 'profile_sub-nav-create-ai-battlecard--config-modal-generate',
      },
      allCardsButton: 'profile_sub-nav-all-cards-button',
      battlecardDrop: {
        button: 'profile_sub-nav-battlecard-drop--button',
        item: 'profile_sub-nav-battlecard-drop--item',
      },
      boardButton: 'profile_sub-nav-board-button',
      filtersDrop: {
        button: 'profile_sub-nav-filters-drop--button',
        closeButton: 'profile_sub-nav-filters-drop--close-button',
        lanesTab: {
          button: 'profile_sub-nav-filters-drop--lanes-tab',
          filterItem: 'profile_sub-nav-filters-drop--lanes-tab_filterItem',
          selectAll: 'profile_sub-nav-filters-drop--lanes-tab_selectAll',
          sort: 'profile_sub-nav-filters-drop--lanes-tab_sort',
        },
        savedViews: {
          cancelViewName: 'profile_my-saved-view--cancel_view_name',
          delete: 'profile_my-saved-view--delete',
          save: 'profile_my-saved-view--save',
          saveViewName: 'profile_my-saved-view--save_view_name',
          select: 'profile_my-saved-view--select_open',
          selectItem: 'profile_my-saved-view--selected_item',
        },
        tagsTab: {
          button: 'profile_sub-nav-filters-drop--tags-tab',
          filterItem: 'profile_sub-nav-filters-drop--tags-tab_filterItem',
          search: 'profile_sub-nav-filters-drop--tags-tab_search',
          selectAll: 'profile_sub-nav-filters-drop--tags-tab_selectAll',
          sort: 'profile_sub-nav-filters-drop--tags-tab_sort',
        },
      },
      newsButton: 'profile_sub-nav-news-button',
      vitalsDrop: {
        button: 'profile_sub-nav-vitals-drop--button',
      },
      viewAsDrop: {
        button: 'profile_sub-nav-view-as-drop--button',
      },
    },
  },
  reports: {
    askKlue: {
      exportDataButton: 'reports--ask-klue-export-export-data-button',
    },
    competitiveAnalytics: {
      importInitialDataButton:
        'reports--competitive-analytics-import-initial-data',
      updateDataButton: 'reports--competitive-analytics-update-data-button',
      uploadDialog: {
        errorCloseButton:
          'reports--competitive-analytics-upload-dialog-error-close-button',
        exportFailedRowsButton:
          'reports--competitive-analytics-upload-dialog-export-failed-rows-button',
        successCloseButton:
          'reports--competitive-analytics-upload-dialog-success-close-button',
      },
    },
    downloadData: 'reports--download-data',
    navigation: {
      'competitive-analytics': {
        'data-hygiene':
          'reports_navigation--competitive-analytics-data-hygiene',
        impact: 'reports_navigation--competitive-analytics-impact',
        overview: 'reports_navigation--competitive-analytics-overview',
        parent: 'reports_navigation--competitive-analytics',
        'rep-performance':
          'reports_navigation--competitive-analytics-rep-performance',
        'threat-analysis':
          'reports_navigation--competitive-analytics-threat-analysis',
      },
      'consumer-usage': {
        leaderboards: 'reports_navigation--consumer-usage-leaderboards',
        overview: 'reports_navigation--consumer-usage-overview',
        parent: 'reports_navigation--consumer-usage',
      },
      curator: 'reports_navigation--curator',
      individual: 'reports_navigation--individual',
    },
    toggleFilters: 'reports--toggle-filters',
  },
  research: {
    note: {
      relatedBoards: {
        addBoardItem: 'research_note-related-boards--add-board-item',
        addBoardMenu: 'research_note-related-boards--add-board-menu',
        board: 'research_note-related-boards--board',
        filter: 'research_note-related-boards--filter',
        remove: 'research_note-related-boards--remove',
        viewBoard: 'research_note-related-boards--view-board',
      },
    },
    sideNav: {
      collapseArrow: 'research_side-nav--collapse-arrow',
      contentHeader: 'research_side-nav--content-header',
      key: 'research_side-nav',
    },
  },
  reviewInsights: {
    filters: {
      customDate: 'review-insights-date-filter-custom',
      date: 'review-insights-date-filter',
      maxRating: 'review-insights-filters-max-rating',
      minRating: 'review-insights-filters-min-rating',
      reset: 'review-insights-filters-reset',
      reviewsFilter: {
        allReviews: 'review-insights-filters-reviews-filter-all-reviews',
        bookmarkedReviews:
          'review-insights-filters-reviews-filter-bookmarked-reviews',
        button: 'review-insights-filters-reviews-filter-button',
        radioGroup: 'review-insights-filters-reviews-filter-radio-group',
      },
      reviewTopic: 'review-insights-filters-review-topic',
      sentimentFilter: {
        all: 'review-insights-filters-sentiment-filter-all',
        button: 'review-insights-filters-sentiment-filter-button',
        negative: 'review-insights-filters-sentiment-filter-negative',
        positive: 'review-insights-filters-sentiment-filter-positive',
      },
      source: {
        filterItem: 'review-insights-source-filter',
        selectAll: 'review-insights-source-filter-select-all',
        sort: 'review-insights-source-filter-sort',
      },
      sourceType: {
        all: 'review-insights-filters-source-type-all',
        button: 'review-insights-filters-source-type-button',
        review: 'review-insights-filters-source-type-review',
        winLoss: 'review-insights-filters-source-type-win-loss',
      },
      starRating: 'review-insights-filters-star-rating',
    },
    header: {
      actionMenu: {
        pin: 'review-insights_header-action-menu-pin',
        unpin: 'review-insights_header-action-menu-unpin',
      },
      itemPrefix: 'review-insights_header--company-item',
      requestCompetitorButton:
        'review-insights_header--request-competitor-button',
      selectedItemPrefix: 'review-insights_header--company-selected',
      sourceLink: 'review-insights_header--source-link',
      title: 'review-insights_header--title',
    },
    insights: {
      createCardButton: 'review-insights_insights--create-card-button',
      createCardSubmitButton: 'review-insights_insights--create-card-submit',
      feedback: {
        feedbackButton: 'review-insights_feedback--feedback-button',
        negativeButton: 'review-insights_feedback--negative-button',
        positiveButton: 'review-insights_feedback--positive-button',
      },
      showMoreButton: 'review-insights_insights--show-more-button',
      sourceButton: 'review-insights_insights--source-button',
    },
    sidebar: {
      breadcrumb: {
        button: 'review-insights_sidebar-breadcrumbs--button',
        item: 'review-insights_sidebar-breadcrumbs--item',
      },
      header: {
        button: 'review-insights_sidebar-header--button',
        title: 'review-insights_sidebar-header--title',
      },
      item: 'review-insights_sidebar--item',
      productItem: 'review-insights_sidebar--product-item',
      reviewCount: 'review-insights_sidebar--review-count',
      searchInput: 'review-insights_sidebar--search-input',
    },
    summary: {
      actionMenu: {
        button: 'review-insights_summary-action-menu--button',
        copyText: 'review-insights_summary-action-menu--copy-text',
        createCard: 'review-insights_summary-action-menu--create-card',
      },
      feedback: 'review-insights_summary--feedback',
      reload: 'review-insights_summary--reload',
      settings: 'review-insights_summary--settings',
    },
    tabs: {
      insights: 'review-insights_tabs--insights',
      reviews: 'review-insights_tabs--reviews',
    },
    themes: {
      actionMenu: {
        button: 'review-insights_themes-action-menu--button',
        hide: 'review-insights_themes-action-menu--hide',
        unhide: 'review-insights_themes-action-menu--unhide',
      },
      allButton: 'review-insights_themes--all-button',
      aspectFilter: 'review-insights_themes--aspect-filter',
      negativeButton: 'review-insights_themes--negative-button',
      positiveButton: 'review-insights_themes--positive-button',
      sortFilterButton: 'review-insights_themes--sort-filter-button',
      title: 'review-insights_themes--title',
    },
    topTopics: {
      item: 'review-insights_top-topics--item',
    },
    createCardModal: {
      titleItemButton: 'review-insights_create-card--title-item-button',
      cancelButton: 'review-insights_create-card--cancel-button',
      saveButton: 'review-insights_create-card--save-button',
      sendToBoardButton: 'review-insights_create-card--send-to-board-button',
      copyUrlButton: 'review-insights_create-card--copy-url-button',
      nextStepButton: 'review-insights_create-card--next-step-button',
      previousStepButton: 'review-insights_create-card--previous-step-button',
      deleteInsightCardButton:
        'review-insights_create-card--delete-insight-card-button',
      cardEditor: {
        title: 'review-insights_create-card--card-editor-title',
        content: 'review-insights_create-card--card-editor-content',
      },
      form: {
        competitor: 'review-insights_create-card--form-competitor',
        cardPermissions: 'review-insights_create-card--form-card-permissions',
        visibilityGroups: 'review-insights_create-card--form-visibility-groups',
        lane: 'review-insights_create-card--form-lane',
        hasOverviewCard: 'review-insights_create-card--form-has-overview-card',
      },
    },
  },
  search: {
    appliedFilters: {
      clearButton: 'search_applied-filters--clear-button',
      overflowButton: 'search_applied-filters--overflow-button',
      removeButton: 'search_applied-filters--remove-button',
    },
    cards: {
      breadcrumb: {
        laneLink: 'search_cards-breadcrumb--lane-link',
        profileLink: 'search_cards-breadcrumb--profile-link',
      },
      empty: {
        feedback: 'search_cards-empty--feedback',
        feedbackInput: 'search_cards-empty--feedback-input',
        cancel: 'search_cards-empty--feedback-cancel',
        positiveSentiment: 'search_cards-empty--positive-sentiment',
        negativeSentiment: 'search_cards-empty--negative-sentiment',
      },
    },
    sidebar: {
      boards: {
        filterItem: 'search_sidebar--boards_filter-item',
        search: 'search_sidebar--boards_search',
        selectAll: 'search_sidebar--boards_select-all',
        sort: 'search_sidebar--boards_sort',
      },
      lastUpdated: {
        filterItem: 'search_sidebar--last-updated_filter-item',
      },
      tags: {
        filterItem: 'search_sidebar--tags_filter-item',
        search: 'search_sidebar--tags_search',
        selectAll: 'search_sidebar--tags_select-all',
        sort: 'search_sidebar--tags_sort',
      },
      toggleCollapse: 'search_sidebar--toggle-collapse',
    },
  },
  settings: {
    boards: {
      confirmDisable: {
        cancel: 'settings_boards--confirm-disable-wide-lanes-cancel',
        confirm: 'settings_boards--confirm-disable-wide-lanes-confirm',
      },
      confirmEnable: {
        cancel: 'settings_boards--confirm-enable-wide-lanes-cancel',
        confirm: 'settings_boards--confirm-enable-wide-lanes-confirm',
      },
      disableWideLanes: 'settings_boards--disable-wide-lanes',
      enableWideLanes: 'settings_boards--enable-wide-lanes',
    },
    chatCustomization: {
      cancel: 'settings_chat-customization--cancel',
      chatTone: 'settings_chat-customization--chat-tone',
      consumerExport: 'settings_chat-customization--consumer-export',
      disableExpandedSources:
        'settings_chat-customization--disable-expanded-sources',
      helpLink: 'settings_chat-customization--help-link',
      salesMethodology: 'settings_chat-customization--sales-methodology',
      save: 'settings_chat-customization--save',
      styleGuidance: 'settings_chat-customization--style-guidance',
    },
    sideMenu: {
      alertsSettings: 'settings_side-menu--alerts-settings',
      boards: 'settings_side-menu--boards',
      chatCustomization: 'settings_side-menu--chat-customization',
      curatorAssignments: 'settings_side-menu--curator-assignments',
      intelDigest: 'settings_side-menu--intel-digest',
      loginDomains: 'settings_side-menu--login-domains',
      monitorsSettings: 'settings_side-menu--monitors-settings',
      notificationPreferences: 'settings_side-menu--notification-preferences',
      ssoSettings: 'settings_side-menu--sso-settings',
      tags: 'settings_side-menu--tags',
    },
    sso: {
      configCheckbox: 'settings_sso--config-checkbox',
      sessionLimitsDefaults: 'settings_sso--session-limits-defaults',
    },
  },
  winLoss: {
    aiSummary: {
      actions: {
        copyText: 'winloss_summary--copy_text',
        kebabMenu: 'winloss_summary--action_menu',
        openCreateCardModal: 'winloss_summary--create_card',
      },
    },
    content: 'winloss_left-menu--content',
    createCardModal: {
      boardLaneSelector: 'winloss_create_card--select_lane',
      boardSelector: 'winloss_create_card--select_competitor',
      cancelButton: 'winloss_create_card--cancel_button',
    },
    createContent: {
      createInterview: 'winloss_create-interview',
      createOpportunity: 'winloss_create-opportunity',
    },
    competitorsMenu: {
      competitorListItem: 'winloss_competitor-menu--list-item',
    },
    decisionThemes: 'winloss_left-menu--themes',
    analysisThemes: 'winloss_left-menu--analysis-themes',
    decisionThemesReports: {
      businessDrivers: 'winloss_themes--business-drivers',
      influencers: 'winloss_themes--influencers',
      lossReasons: 'winloss_themes--loss-reasons',
      pricingNegatives: 'winloss_themes--pricing_negatives',
      pricingPositives: 'winloss_themes--pricing_positives',
      productNegatives: 'winloss_themes--product_negatives',
      productPositives: 'winloss_themes--product_positives',
      salesNegatives: 'winloss_themes--sales_negatives',
      salesPositives: 'winloss_themes--sales_positives',
      selectionCriteria: 'winloss_themes--selection-criteria',
      winReasons: 'winloss_themes--win-reasons',
    },
    featuredQuote: 'winloss_program-list--quote',
    featuredQuoteList: 'winloss_program-list--quote-view-all',
    filterBar: {
      clearFilters: 'winloss_filter-bar--cleared',
    },
    globalNav: 'app-nav-bar_win-loss',
    highlightItems: {
      kebabMenu: 'winloss_highlights--action_menu',
      kebabMenuCopyOption: 'winloss_highlights--copy_text',
      kebabMenuSendToKlueOption: 'winloss_highlights--create_card',
    },
    highlightsLayoutToggle: 'winloss_highlights--list_toggle',
    interviewAnalysis: {
      deleteButton: 'winloss_interview-analysis--delete-interview',
    },
    interviewCard: 'winloss_explorer--interview',
    interviews: 'winloss_left-menu--interviews',
    interviewDecisionReasons: {
      thumbsDown: 'winloss_outcome-reasons--thumbs_down',
      thumbsUp: 'winloss_outcome-reasons--thumbs_up',
    },
    interviewSummary: {
      collapse: 'winloss_interview-summary--meta_collapse',
      downloadAsPdfButton: 'winloss_interview--download_pdf',
      editCloseButton: 'winloss_interview--edit_close',
      editSaveExitButton: 'winloss_interview--edit_save_exit',
      editSourceButton: 'winloss_interview--edit_source',
      expand: 'winloss_interview-summary--meta_expand',
      sourceCloseButton: 'winloss_interview--source_close',
      sourceSaveButton: 'winloss_interview--source_save_close',
    },
    outreach: 'winloss_left-menu--outreach',
    opportunities: 'winloss_left-menu--opportunities',
    opportunityTile: 'winloss_opportunities--opportunity-tile',
    opportunity: {
      details: 'winloss_opportunity--details',
      overviewSummary: {
        edit: 'winloss_opportunity--overview-summary-edit',
        generateButton: 'winloss_opportunity--overview-summary-generate-button',
        refresh: 'winloss_opportunity--overview-summary-refresh',
      },
      overviewTab: 'winloss_opportunity--overview-tab',
      reportsTab: 'winloss_opportunity--reports-tab',
      interviewsTab: 'winloss_opportunity--interviews-tab',
      surveysTab: 'winloss_opportunity--surveys-tab',
    },
    promoPage: {
      takeTheTourButton: 'winloss_promo-page--take-tour',
    },
    analytics: 'winloss_left-menu--analytics',
    threatAnalysis: 'winloss_left-menu--threat-analysis',
    dataHygiene: 'winloss_left-menu--data-hygiene',
    clickableOpportunityRow: 'winloss_opportunities--list-item',
    overview: 'winloss_left-menu--overview',
    programs: 'winloss_left-menu--programs',
    allInterviews: 'winloss_left-menu--all-interviews',
    clips: 'winloss_left-menu--clips',
    program: 'winloss_program-list--program',
    programDashboard: {
      highlight: 'winloss--highlight-item',
      interviews: 'winloss_program--interviews',
      interviewsList: 'winloss_program--interviews-view-all',
      quotesList: 'winloss_program--quotes-view-all',
      reports: 'winloss_program--reports',
      themesList: 'winloss_program--themes-view-all',
    },
    programActions: {
      kebabMenu: 'winloss_program--action_menu',
      kebabMenuEditOption: 'winloss_program--edit_program',
      kebabMenuDeleteOption: 'winloss_program--delete_program',
    },
    programSurveys: 'winloss_left-menu--surveys',
    programLossAnalysis: 'winloss_left-menu--loss-analysis',
    programOtherAnalysis: 'winloss_left-menu--other-analysis',
    programChurnAnalysis: 'winloss_left-menu--churn-analysis',
    programWinAnalysis: 'winloss_left-menu--win-analysis',
    recentInterview: 'winloss_program-list--interview',
    recentInterviewList: 'winloss_program-list--interview-view-all',
    recentSurvey: 'winloss_program-list--survey',
    recentSurveyList: 'winloss_program-list--survey-view-all',
    reports: 'winloss_left-menu--reports',
    surveyDetails: {
      summary: {
        collapse: 'winloss_interview-summary--meta_collapse',
        expand: 'winloss_interview-summary--meta_expand',
      },
    },
    surveyItems: {
      kebabMenu: 'winloss_surveys--action_menu',
      kebabMenuOption: 'winloss_surveys--go-to-results-dashboard',
    },
    surveyOutreach: {
      sendOutreachButton: 'winloss_opportunities-detail--send-button',
      dismissOutreachButton: 'winloss_opportunities-detail--dismiss-button',
      undoDismissOutreachButton: 'winloss_opportunities-detail--undo-button',
      viewSurveyForm: 'winloss_opportunities-detail--view-survey',
      surveyFormRespondentEmail:
        'winloss_opportunities-detail--respondent-email',
      surveyFormCopyUrl: 'winloss_opportunities-detail--copy-survey-url',
      surveyFormCopyRespondentEmail:
        'winloss_opportunities-detail--copy-respondent-email',
      surveyFormCopyOwnerEmail:
        'winloss_opportunities-detail--copy-owner-email',
      viewSurveyResponses:
        'winloss_opportunities-detail--view-survey-responses',
      surveyFormOwnerEmail: 'winloss_opportunities-detail--owner-email',
    },
    dealOutreach: {
      selectContact: 'winloss_confirmation--select-contact',
      sendSurveryButton: 'winloss_confirmation--submit-button',
      dismissSendSurveyButton: 'winloss_confirmation--dismiss-button',
    },
    sideMenu: {
      collapseAction: 'winloss-left-menu--toggle-collapse',
      decisionThemesFlyout: 'winloss_left-menu--themes-list-item',
    },
    surveys: 'winloss_left-menu--survey-promo',
    winLossNav: 'winloss_left-menu--win-loss',
    publicPages: {
      socialMediaIcons: {
        x: 'winloss_confirmation--social-twitter',
        facebook: 'winloss_confirmation--social-facebook',
        blog: 'winloss_confirmation--social-blog',
        wellfound: 'winloss_confirmation--social-wellfound',
        linkedIn: 'winloss_confirmation--social-linkedin',
      },
      legal: {
        acceptableUse: 'winloss_confirmation--acceptable-use',
        privacy: 'winloss_confirmation--privacy',
        terms: 'winloss_confirmation--terms',
      },
    },
  },
  userManagement: {
    invite: {
      copySsoLink: 'user-management_invite--copy-sso-link',
      manageSso: 'user-management_invite--manage-sso',
    },
  },
  labs: {
    launcher: {
      tile: 'labs_launcher--tile',
      publishPlugin: 'labs_launcher--publish-plugin',
      createPlugin: 'labs_launcher--create-plugin',
    },
    // LabsHomePage (post-design-handoff) — three promo cards + the
    // Lab settings pill in the footer strip.
    home: {
      browse: 'labs_home--browse',
      myApps: 'labs_home--my-apps',
      create: 'labs_home--create',
      labSettings: 'labs_home--lab-settings',
    },
    admin: {
      archive: 'labs_admin--archive',
      disable: 'labs_admin--disable',
      enable: 'labs_admin--enable',
      viewPlugin: 'labs_admin--view-plugin',
      ancestry: 'labs_admin--ancestry',
    },
    approvalQueue: {
      approve: 'labs_approval-queue--approve',
      reject: 'labs_approval-queue--reject',
      forceApprove: 'labs_approval-queue--force-approve',
      rejectModalCancel: 'labs_approval-queue--reject-modal-cancel',
      rejectModalSubmit: 'labs_approval-queue--reject-modal-submit',
    },
    upload: {
      publish: 'labs_upload--publish',
      removeBundle: 'labs_upload--remove-bundle',
    },
    dev: {
      load: 'labs_dev--load',
    },
    builder: {
      create: 'labs_builder--create',
      send: 'labs_builder--send',
      publish: 'labs_builder--publish',
      clone: 'labs_builder--clone',
      edit: 'labs_builder--edit',
      newDraft: 'labs_builder--new-draft',
      discard: 'labs_builder--discard',
    },
    // Phase 4: tile-level + per-app navbar tracking. The navbar.* keys cover
    // both the published Open view and the builder Edit view (one component).
    myApps: {
      open: 'labs_my-apps--open',
      edit: 'labs_my-apps--edit',
      uninstall: 'labs_my-apps--uninstall',
      disable: 'labs_my-apps--disable',
      enable: 'labs_my-apps--enable',
    },
    browse: {
      get: 'labs_browse--get',
      open: 'labs_browse--open',
    },
    manage: {
      open: 'labs_manage--open',
      disable: 'labs_manage--disable',
      enable: 'labs_manage--enable',
    },
    // Tile-click "App details" modal (read-only details + permissions).
    details: {
      open: 'labs_details--open',
      enable: 'labs_details--enable',
      uninstall: 'labs_details--uninstall',
      close: 'labs_details--close',
    },
    navbar: {
      appDetails: 'labs_navbar--app-details',
      back: 'labs_navbar--back',
      history: 'labs_navbar--history',
      clone: 'labs_navbar--clone',
      publish: 'labs_navbar--publish',
      discard: 'labs_navbar--discard',
      approve: 'labs_navbar--approve',
      reject: 'labs_navbar--reject',
      disable: 'labs_navbar--disable',
      enable: 'labs_navbar--enable',
      get: 'labs_navbar--get',
      uninstall: 'labs_navbar--uninstall',
    },
    // One-time experimental-area disclaimer modal (LabsDisclaimerGate).
    disclaimer: {
      cancel: 'labs_disclaimer--cancel',
      continue: 'labs_disclaimer--continue',
    },
  },
};

export default TRACKING_IDS;
